/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
  Easing,
} from "react-native";
import { interpolate } from "flubber";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="234" height="329" viewBox="0 0 234 329" fill="none"> <desc id="IMP.BLUE">{"#LoadingImage":{"type":"SELECTOR","constraint":"none","width":538,"height":369},"#state_3Dup":{"type":"SELECTOR","constraint":"none","width":234,"height":329},"#Logo":{"type":"SELECTOR","constraint":"xMinYMin meet","width":50.00025177001953,"height":50.00001525878906},"#Background":{"type":"SELECTOR","constraint":"xMinYMin meet","width":50,"height":50},"#LogoText":{"type":"SELECTOR","constraint":"none","width":44.53328323364258,"height":44.53328323364258},"#Vector":{"type":"SELECTOR","constraint":"none","width":2.6718084812164307,"height":3.901681900024414},"#Ellipse_201":{"type":"SELECTOR","constraint":"xMinYMin meet","width":46,"height":12},"#state_3Ddown":{"type":"SELECTOR","constraint":"none","width":234,"height":329},"transforms":{"Logo":[{"name":"Logo","relativeTransforms":[[1,-5.551115123125783e-17,92],[5.551115123125783e-17,1,87]],"rotation":-3.1805546814635168e-15,"instanceParentName":"Logo","isInstanceParent":true,"isInstanceChild":false,"width":50.00025177001953,"height":50.00001525878906},{"name":"Logo","relativeTransforms":[[1,-5.551115123125783e-17,92],[5.551115123125783e-17,1,90]],"rotation":-3.1805546814635168e-15,"instanceParentName":"Logo","isInstanceParent":true,"isInstanceChild":false,"width":50.00025177001953,"height":50.00001525878906}],"Background":[{"name":"Background","relativeTransforms":[[1,5.551115123125783e-17,0.00025022029876708984],[-5.551115123125783e-17,1,0.000014066696166992188]],"rotation":3.1805546814635168e-15,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":50,"height":50},{"name":"Background","relativeTransforms":[[1,5.551115123125783e-17,0.00025022029876708984],[-5.551115123125783e-17,1,0.000014066696166992188]],"rotation":3.1805546814635168e-15,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":50,"height":50}],"LogoText":[{"name":"LogoText","relativeTransforms":[[1,0,2.7965633869171143],[0,1,2.7965939044952393]],"rotation":0,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":44.53328323364258,"height":44.53328323364258},{"name":"LogoText","relativeTransforms":[[1,0,2.7965633869171143],[0,1,2.7965939044952393]],"rotation":0,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":44.53328323364258,"height":44.53328323364258}],"Vector":[{"name":"Vector","relativeTransforms":[[1,-1.1859199768411092e-16,3.2646484971046448],[1.1859199768411092e-16,1,3.2646790146827698]],"rotation":-6.794820951324789e-15,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":43.597110748291016,"height":43.597110748291016},{"name":"Vector","relativeTransforms":[[1,-2.3718399536822184e-16,9.477539300918579],[2.3718399536822184e-16,1,9.477630853652954]],"rotation":-1.3589641902649577e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":31.171092987060547,"height":31.171092987060547},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,9.922851800918579],[3.5577599305233276e-16,1,10.262207269668579]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.011082887649536,"height":3.0746989250183105},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,13.782226800918579],[3.5577599305233276e-16,1,8.078186273574829]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.586989641189575,"height":2.6718058586120605},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,17.49316430091858],[3.5577599305233276e-16,1,6.636199951171875]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.0144548416137695,"height":2.1204822063446045},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,21.204100847244263],[3.5577599305233276e-16,1,5.787841796875]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.7812068462371826,"height":2.120481491088867},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,24.681639909744263],[3.5577599305233276e-16,1,5.44879150390625]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.4419262409210205,"height":2.120481252670288},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,27.755858659744263],[3.5577599305233276e-16,1,5.8568115234375]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.8448207378387451,"height":2.150313377380371},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,30.746093034744263],[3.5577599305233276e-16,1,6.869354486465454]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.8024108409881592,"height":2.3537354469299316},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,34.05468678474426],[3.5577599305233276e-16,1,8.290313959121704]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.3783069849014282,"height":2.5445775985717773},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,36.577149629592896],[3.5577599305233276e-16,1,10.368194818496704]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.48095965385437,"height":2.5233747959136963},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,7.569336175918579],[3.5577599305233276e-16,1,33.31155323982239]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.693009853363037,"height":2.6294004917144775},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,9.816406488418579],[3.5577599305233276e-16,1,36.34390377998352]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.5021708011627197,"height":2.459760904312134},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,12.870117425918579],[3.5577599305233276e-16,1,38.464478731155396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0110890865325928,"height":2.9898886680603027},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,18.892577409744263],[3.5577599305233276e-16,1,41.687379121780396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.781203269958496,"height":2.332533121109009},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,21.931639909744263],[3.5577599305233276e-16,1,42.65469479560852]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.9999092817306519,"height":2.1159110069274902},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,25.762694597244263],[3.5577599305233276e-16,1,42.705384492874146]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.7600010633468628,"height":2.162886619567871},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,29.049803972244263],[3.5577599305233276e-16,1,41.87826657295227]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.162893772125244,"height":2.48095965385437},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,34.34179615974426],[3.5577599305233276e-16,1,39.673035860061646]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.0159671306610107,"height":2.107593536376953},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,36.789063692092896],[3.5577599305233276e-16,1,38.125123262405396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.6115673780441284,"height":1.7387951612472534},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,38.188477754592896],[3.5577599305233276e-16,1,35.62295651435852]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.2689156532287598,"height":2.099283456802368},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,40.139649629592896],[3.5577599305233276e-16,1,32.76019215583801]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.353739023208618,"height":1.9508445262908936},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,19.783202409744263],[3.5577599305233276e-16,1,17.047760248184204]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0746994018554688,"height":3.8168673515319824},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,23.706053972244263],[4.743679907364437e-16,1,17.090179681777954]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.2019307613372803,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.947264909744263],[4.743679907364437e-16,1,17.04797387123108]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.3749520778656006,"height":3.8380696773529053},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,17.53613305091858],[3.5577599305233276e-16,1,23.154906511306763]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":4.495420932769775,"height":3.774454116821289},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,22.709960222244263],[4.743679907364437e-16,1,23.176177263259888]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.8168673515319824,"height":3.7532553672790527},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.311522722244263],[4.743679907364437e-16,1,23.154937028884888]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":0.7633774280548096,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,29.071288347244263],[4.743679907364437e-16,1,23.155028581619263]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.4987871646881104,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,19.931639909744263],[4.743679907364437e-16,1,29.176818132400513]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0746994018554688,"height":3.816870927810669},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,23.048827409744263],[4.743679907364437e-16,1,29.240508317947388]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.816870927810669,"height":3.7532553672790527},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.501952409744263],[4.743679907364437e-16,1,29.155730485916138]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.6718084812164307,"height":3.901681900024414},{"name":"Vector","relativeTransforms":[[1,-1.1859199768411092e-16,3.2646484971046448],[1.1859199768411092e-16,1,3.2646790146827698]],"rotation":-6.794820951324789e-15,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":43.597110748291016,"height":43.597110748291016},{"name":"Vector","relativeTransforms":[[1,-2.3718399536822184e-16,9.477539300918579],[2.3718399536822184e-16,1,9.477630853652954]],"rotation":-1.3589641902649577e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":31.171092987060547,"height":31.171092987060547},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,9.922851800918579],[3.5577599305233276e-16,1,10.262207269668579]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.011082887649536,"height":3.0746989250183105},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,13.782226800918579],[3.5577599305233276e-16,1,8.078186273574829]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.586989641189575,"height":2.6718058586120605},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,17.49316430091858],[3.5577599305233276e-16,1,6.636199951171875]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.0144548416137695,"height":2.1204822063446045},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,21.204100847244263],[3.5577599305233276e-16,1,5.787841796875]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.7812068462371826,"height":2.120481491088867},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,24.681639909744263],[3.5577599305233276e-16,1,5.44879150390625]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.4419262409210205,"height":2.120481252670288},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,27.755858659744263],[3.5577599305233276e-16,1,5.8568115234375]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.8448207378387451,"height":2.150313377380371},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,30.746093034744263],[3.5577599305233276e-16,1,6.869354486465454]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.8024108409881592,"height":2.3537354469299316},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,34.05468678474426],[3.5577599305233276e-16,1,8.290313959121704]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.3783069849014282,"height":2.5445775985717773},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,36.577149629592896],[3.5577599305233276e-16,1,10.368194818496704]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.48095965385437,"height":2.5233747959136963},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,7.569336175918579],[3.5577599305233276e-16,1,33.31155323982239]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.693009853363037,"height":2.6294004917144775},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,9.816406488418579],[3.5577599305233276e-16,1,36.34390377998352]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.5021708011627197,"height":2.459760904312134},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,12.870117425918579],[3.5577599305233276e-16,1,38.464478731155396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0110890865325928,"height":2.9898886680603027},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,18.892577409744263],[3.5577599305233276e-16,1,41.687379121780396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.781203269958496,"height":2.332533121109009},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,21.931639909744263],[3.5577599305233276e-16,1,42.65469479560852]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.9999092817306519,"height":2.1159110069274902},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,25.762694597244263],[3.5577599305233276e-16,1,42.705384492874146]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.7600010633468628,"height":2.162886619567871},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,29.049803972244263],[3.5577599305233276e-16,1,41.87826657295227]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.162893772125244,"height":2.48095965385437},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,34.34179615974426],[3.5577599305233276e-16,1,39.673035860061646]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.0159671306610107,"height":2.107593536376953},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,36.789063692092896],[3.5577599305233276e-16,1,38.125123262405396]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":1.6115673780441284,"height":1.7387951612472534},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,38.188477754592896],[3.5577599305233276e-16,1,35.62295651435852]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.2689156532287598,"height":2.099283456802368},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,40.139649629592896],[3.5577599305233276e-16,1,32.76019215583801]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.353739023208618,"height":1.9508445262908936},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,19.783202409744263],[3.5577599305233276e-16,1,17.047760248184204]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0746994018554688,"height":3.8168673515319824},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,23.706053972244263],[4.743679907364437e-16,1,17.090179681777954]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.2019307613372803,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.947264909744263],[4.743679907364437e-16,1,17.04797387123108]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.3749520778656006,"height":3.8380696773529053},{"name":"Vector","relativeTransforms":[[1,-3.5577599305233276e-16,17.53613305091858],[3.5577599305233276e-16,1,23.154906511306763]],"rotation":-2.0384462853974367e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":4.495420932769775,"height":3.774454116821289},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,22.709960222244263],[4.743679907364437e-16,1,23.176177263259888]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.8168673515319824,"height":3.7532553672790527},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.311522722244263],[4.743679907364437e-16,1,23.154937028884888]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":0.7633774280548096,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,29.071288347244263],[4.743679907364437e-16,1,23.155028581619263]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.4987871646881104,"height":3.7744557857513428},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,19.931639909744263],[4.743679907364437e-16,1,29.176818132400513]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.0746994018554688,"height":3.816870927810669},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,23.048827409744263],[4.743679907364437e-16,1,29.240508317947388]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":3.816870927810669,"height":3.7532553672790527},{"name":"Vector","relativeTransforms":[[1,-4.743679907364437e-16,27.501952409744263],[4.743679907364437e-16,1,29.155730485916138]],"rotation":-2.7179283805299154e-14,"instanceParentName":"Logo","isInstanceParent":false,"isInstanceChild":true,"width":2.6718084812164307,"height":3.901681900024414}]},"morph":{"condition":"props.morph","targets":{"state=up":{"type":"ease","duration":500,"delay":0},"state=down":{"type":"ease","duration":500,"delay":0}},"numStates":2}}</desc>
 * <g id="state=up">
 * <g id="Logo">
 * <circle id="Background" cx="117" cy="112" r="25" fill="#2C4B46"/>
 * <path id="LogoText" fill-rule="evenodd" clip-rule="evenodd" d="M95.733 112.063C95.733 100.283 105.283 90.7327 117.064 90.7327C128.844 90.7327 138.394 100.283 138.394 112.063C138.394 123.844 128.844 133.394 117.064 133.394C105.283 133.394 95.733 123.844 95.733 112.063ZM117.064 89.7966C104.766 89.7966 94.7969 99.7657 94.7969 112.063C94.7969 124.361 104.766 134.33 117.064 134.33C129.361 134.33 139.33 124.361 139.33 112.063C139.33 99.7657 129.361 89.7966 117.064 89.7966ZM101.813 112.063C101.813 103.64 108.641 96.8124 117.063 96.8124C125.486 96.8124 132.314 103.64 132.314 112.063C132.314 120.486 125.486 127.314 117.063 127.314C108.641 127.314 101.813 120.486 101.813 112.063ZM117.063 96.1428C108.271 96.1428 101.143 103.271 101.143 112.063C101.143 120.856 108.271 127.983 117.063 127.983C125.856 127.983 132.984 120.856 132.984 112.063C132.984 103.271 125.856 96.1428 117.063 96.1428ZM102.623 98.7889L102.793 98.5981L103.514 98.9162L103.174 98.1952L103.344 98.0044L103.747 98.895L104.616 99.2342L103.832 97.4742L104.044 97.2622L104.934 99.3615L104.807 99.5523L103.789 99.1706L104.213 100.167L104.044 100.337L101.923 99.5099L102.114 99.2978L103.895 100.04L103.535 99.1706L102.623 98.7889ZM108.37 96.8594L107.224 95.0782L106.991 95.2266L107.479 95.99L106.504 96.6049L106.016 95.8415L105.783 95.99L106.928 97.75L107.161 97.6227L106.652 96.817L107.627 96.202L108.136 97.0078L108.37 96.8594ZM110.872 95.693C110.723 95.7355 110.596 95.7567 110.469 95.7567C110.342 95.7355 110.214 95.7142 110.087 95.6506C109.96 95.587 109.875 95.5022 109.769 95.3962C109.684 95.2902 109.621 95.1841 109.557 95.0569C109.515 94.9297 109.493 94.7812 109.493 94.654C109.493 94.5268 109.515 94.3783 109.578 94.2511C109.621 94.1239 109.706 94.0179 109.79 93.9118C109.875 93.8058 110.002 93.7422 110.13 93.6998C110.278 93.6574 110.405 93.6362 110.533 93.6362C110.66 93.6574 110.787 93.6998 110.914 93.7634C111.041 93.827 111.126 93.9118 111.232 94.0179C111.317 94.1239 111.381 94.2299 111.444 94.3571C111.487 94.4844 111.508 94.6328 111.508 94.76C111.508 94.8873 111.487 95.0357 111.423 95.1629C111.381 95.2902 111.296 95.3962 111.211 95.5022C111.126 95.6082 110.999 95.6506 110.872 95.693ZM109.812 94.9509C109.854 95.0569 109.896 95.1417 109.96 95.2265C110.024 95.3114 110.108 95.375 110.193 95.4174C110.278 95.4598 110.363 95.5022 110.469 95.5022C110.575 95.5234 110.66 95.5022 110.766 95.4598C110.872 95.4174 110.957 95.3538 111.02 95.2902C111.084 95.2053 111.126 95.1205 111.169 95.0357C111.211 94.9509 111.211 94.8449 111.211 94.7388C111.211 94.6328 111.19 94.5268 111.147 94.442C111.105 94.3359 111.063 94.2511 110.999 94.1663C110.935 94.0815 110.851 94.0179 110.766 93.9755C110.681 93.933 110.575 93.8906 110.49 93.8906C110.384 93.8906 110.299 93.8906 110.193 93.933C110.087 93.9755 110.002 94.0391 109.939 94.1027C109.875 94.1875 109.833 94.2723 109.79 94.3571L109.79 94.3571L109.781 94.4023C109.763 94.4884 109.748 94.5634 109.748 94.654L109.748 94.6541C109.769 94.7601 109.79 94.8661 109.812 94.9509ZM113.204 92.8302L113.544 94.9083L114.986 94.675L114.943 94.4418L113.777 94.6326L113.459 92.7878L113.204 92.8302ZM118.103 94.336V94.5692L116.682 94.548L116.724 92.4488L118.124 92.47V92.7032L116.979 92.682V93.3606L117.975 93.3818V93.5938L116.979 93.5726L116.958 94.2936L118.103 94.336ZM121.219 93.212C121.304 93.2756 121.368 93.3392 121.41 93.4028L121.601 93.2544C121.516 93.1696 121.431 93.0847 121.325 93.0211C121.219 92.9575 121.092 92.8939 120.965 92.8727C120.816 92.8515 120.689 92.8515 120.562 92.8727C120.456 92.8939 120.35 92.9363 120.265 93.0211C120.18 93.1059 120.117 93.212 120.095 93.3392C120.074 93.4452 120.074 93.53 120.117 93.6149C120.159 93.6997 120.223 93.7633 120.307 93.8269L120.308 93.8269C120.414 93.8905 120.52 93.9541 120.647 94.0178C120.719 94.0467 120.792 94.0856 120.857 94.1209L120.857 94.1209C120.888 94.1372 120.917 94.1528 120.944 94.1662C121.007 94.2086 121.071 94.251 121.113 94.3146C121.134 94.357 121.156 94.4206 121.134 94.5055C121.113 94.6115 121.05 94.6751 120.965 94.7175C120.88 94.7599 120.753 94.7599 120.604 94.7387C120.498 94.7175 120.392 94.6751 120.307 94.6327C120.223 94.5903 120.138 94.5479 120.074 94.4843C120.039 94.4492 120.011 94.4142 119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827C119.964 94.357 119.945 94.3337 119.926 94.3146L119.756 94.5055C119.968 94.7599 120.223 94.9084 120.541 94.972C120.689 95.0144 120.816 95.0144 120.944 94.9932C121.05 94.9932 121.156 94.9296 121.241 94.8659C121.325 94.8023 121.389 94.6963 121.41 94.5691C121.431 94.4418 121.431 94.3358 121.389 94.251C121.347 94.1662 121.283 94.0814 121.177 94.0178C121.092 93.9541 120.965 93.8905 120.838 93.8269L120.541 93.6785C120.477 93.6361 120.414 93.5724 120.392 93.53C120.371 93.4664 120.35 93.4028 120.371 93.3392C120.392 93.2332 120.456 93.1484 120.541 93.1059C120.626 93.0635 120.732 93.0423 120.901 93.0847C121.028 93.1059 121.134 93.1484 121.219 93.212ZM124.337 93.8693L124.549 93.9541V96.2231L124.294 96.117V95.4597L123.467 95.1204L123.001 95.6081L122.746 95.5021L124.337 93.8693ZM124.316 95.2264L124.337 94.1874L123.616 94.9508L124.316 95.2264ZM127.2 95.2903L126.055 97.0503L127.264 97.8349L127.391 97.644L126.415 97.0079L127.433 95.4387L127.2 95.2903ZM129.786 99.7219L129.616 99.8915L128.577 98.8949L130.041 97.3682L131.058 98.3436L130.889 98.5132L130.062 97.7287L129.595 98.2164L130.316 98.8949L130.168 99.0646L129.447 98.386L128.938 98.9161L129.786 99.7219ZM99.6969 121.626L101.075 120.799L100.333 122.729L100.46 122.941L102.263 121.859L102.135 121.605L100.715 122.453L101.478 120.502L101.372 120.312L99.5696 121.393L99.6969 121.626ZM102.941 125.655L102.771 125.804L101.817 124.743L103.386 123.344L104.319 124.383L104.149 124.531L103.386 123.683L102.877 124.128L103.534 124.871L103.365 125.019L102.707 124.277L102.156 124.765L102.941 125.655ZM106.397 126.207L106.185 126.058L105.952 127.012L105.146 127.5L105.634 125.634L105.401 125.464L104.87 127.691L105.061 127.818L105.994 127.267L105.74 128.327L105.931 128.454L107.882 127.267L107.648 127.097L106.015 128.136L106.228 127.224L107.055 126.694L106.842 126.546L106.185 126.97L106.397 126.207ZM111.19 128.793L111.465 130.023L112.398 129.154L112.674 129.239L111.508 130.278L111.275 131.02L111.02 130.935L111.253 130.193L110.893 128.687L111.19 128.793ZM114.412 131.635C114.518 131.699 114.646 131.741 114.794 131.762C114.943 131.783 115.07 131.762 115.197 131.72C115.324 131.677 115.43 131.614 115.536 131.529C115.642 131.444 115.727 131.338 115.791 131.211C115.854 131.105 115.897 130.978 115.918 130.829C115.939 130.681 115.939 130.554 115.897 130.426C115.854 130.299 115.812 130.172 115.727 130.066C115.663 129.96 115.557 129.875 115.451 129.79C115.345 129.727 115.218 129.684 115.07 129.663C114.921 129.642 114.794 129.663 114.667 129.705C114.54 129.748 114.434 129.811 114.328 129.896C114.222 129.981 114.137 130.087 114.073 130.214C114.009 130.32 113.967 130.448 113.946 130.596C113.925 130.723 113.925 130.872 113.967 130.999C114.009 131.126 114.052 131.253 114.137 131.359C114.2 131.465 114.306 131.571 114.412 131.635ZM114.222 130.935C114.2 130.829 114.179 130.723 114.2 130.617C114.222 130.511 114.243 130.426 114.285 130.32C114.328 130.214 114.391 130.129 114.455 130.066C114.54 129.981 114.624 129.939 114.709 129.896C114.815 129.854 114.921 129.833 115.027 129.854C115.133 129.875 115.218 129.896 115.303 129.96C115.388 130.023 115.451 130.087 115.515 130.172C115.579 130.257 115.621 130.342 115.642 130.448C115.663 130.554 115.685 130.66 115.663 130.766L115.663 130.766C115.642 130.872 115.621 130.978 115.579 131.063C115.536 131.169 115.473 131.253 115.409 131.317C115.324 131.402 115.239 131.444 115.155 131.487C115.049 131.529 114.943 131.55 114.836 131.529C114.709 131.508 114.624 131.487 114.54 131.423C114.455 131.359 114.391 131.296 114.328 131.211C114.285 131.126 114.243 131.041 114.222 130.935ZM117.933 131.868L117.763 129.769L118.654 129.705C118.738 129.705 118.823 129.705 118.908 129.748C118.993 129.79 119.057 129.833 119.12 129.875C119.184 129.939 119.226 130.002 119.269 130.087C119.311 130.172 119.332 130.235 119.332 130.32C119.332 130.426 119.332 130.511 119.29 130.596C119.271 130.669 119.222 130.742 119.181 130.802L119.163 130.829C119.099 130.893 119.035 130.935 118.95 130.978L119.523 131.741L119.226 131.762L118.696 131.041L118.145 131.084L118.208 131.847L117.933 131.868ZM118.102 130.85L118.738 130.808C118.802 130.808 118.866 130.787 118.929 130.723C118.972 130.681 119.014 130.617 119.035 130.554C119.057 130.49 119.078 130.405 119.056 130.342C119.056 130.257 119.035 130.193 118.993 130.129C118.95 130.066 118.908 130.023 118.844 129.981C118.781 129.939 118.717 129.939 118.654 129.939L118.039 129.981L118.102 130.85ZM121.05 129.324L121.601 131.359L121.835 131.274L121.665 130.659L121.92 130.214L122.916 130.999L123.213 130.914L122.047 130.002L122.619 128.878L122.344 128.963L121.601 130.384L121.305 129.26L121.05 129.324ZM126.521 128.263C126.457 128.157 126.393 128.03 126.372 127.903C126.351 127.776 126.33 127.648 126.351 127.521C126.372 127.394 126.415 127.267 126.478 127.14C126.539 127.018 126.639 126.935 126.758 126.835L126.758 126.835L126.758 126.835L126.775 126.821C126.923 126.715 127.093 126.673 127.241 126.673C127.411 126.673 127.538 126.715 127.666 126.779L127.56 127.012C127.475 126.97 127.39 126.927 127.305 126.927C127.22 126.927 127.135 126.927 127.072 126.949C126.987 126.97 126.923 126.991 126.881 127.033C126.775 127.097 126.711 127.182 126.669 127.267C126.627 127.352 126.584 127.458 126.584 127.542C126.584 127.648 126.584 127.733 126.605 127.839C126.627 127.945 126.669 128.03 126.733 128.115C126.796 128.2 126.86 128.285 126.945 128.348C127.029 128.412 127.114 128.454 127.22 128.497L127.247 128.502C127.341 128.521 127.42 128.537 127.517 128.518C127.623 128.518 127.708 128.475 127.793 128.412C127.856 128.369 127.92 128.327 127.962 128.263C128.005 128.2 128.047 128.136 128.068 128.051C128.09 127.967 128.111 127.882 128.09 127.776L128.344 127.754C128.365 127.86 128.365 127.988 128.323 128.094C128.281 128.2 128.238 128.306 128.153 128.391C128.09 128.475 128.005 128.56 127.899 128.624C127.772 128.709 127.644 128.751 127.517 128.772C127.39 128.793 127.241 128.772 127.114 128.73C126.987 128.687 126.86 128.624 126.754 128.539C126.669 128.475 126.584 128.369 126.521 128.263ZM128.789 125.295L130.21 126.864L130.401 126.694L128.98 125.125L128.789 125.295ZM131.482 122.75L131.016 123.323L132.458 124.51L132.288 124.722L130.846 123.535L130.38 124.107L130.189 123.959L131.27 122.623L131.482 122.75ZM133.539 121.117L132.267 121.138L132.14 121.393L133.688 121.329L134.366 121.711L134.494 121.478L133.815 121.117L133.031 119.76L132.882 120.015L133.539 121.117ZM114.858 104.048L114.71 104.578H114.689C114.604 104.472 114.455 104.429 114.243 104.429H113.586V107.504C113.586 107.61 113.628 107.716 113.713 107.801V107.865H112.929V107.822C113.013 107.737 113.056 107.631 113.056 107.525V104.451H112.356C112.123 104.451 111.974 104.493 111.826 104.641L111.784 104.62L111.996 104.048H112.017C112.08 104.069 112.144 104.09 112.229 104.09H114.646C114.731 104.09 114.795 104.069 114.858 104.048ZM118.802 107.525V104.429C118.802 104.323 118.845 104.217 118.908 104.133V104.09H118.145C118.23 104.217 118.272 104.493 118.272 104.705V105.532H116.343V104.705C116.343 104.493 116.385 104.239 116.47 104.09H115.706V104.133C115.77 104.217 115.812 104.323 115.812 104.429V107.504C115.812 107.61 115.77 107.716 115.706 107.801V107.843H116.47C116.385 107.716 116.343 107.441 116.343 107.228V105.893H118.272V107.25C118.272 107.462 118.23 107.716 118.145 107.865H118.908V107.822C118.845 107.737 118.802 107.631 118.802 107.525ZM122.323 107.186L122.089 107.886C122.026 107.865 121.962 107.844 121.877 107.844H119.948V107.801C120.011 107.716 120.054 107.61 120.054 107.504V104.43C120.054 104.324 120.011 104.218 119.948 104.133V104.09H121.729C121.835 104.09 121.941 104.09 122.026 104.048H122.047V104.748H122.026C121.92 104.514 121.814 104.43 121.496 104.43H120.584V105.532H121.474C121.559 105.532 121.623 105.511 121.665 105.469H121.686V105.978H121.665C121.559 105.914 121.453 105.872 121.347 105.872H120.584V107.504H121.58C121.962 107.504 122.153 107.335 122.301 107.165L122.323 107.186ZM114.032 113.929V113.887C113.968 113.802 113.862 113.59 113.841 113.208L113.65 110.494C113.629 110.388 113.693 110.282 113.777 110.197V110.155H112.972L111.784 112.89L110.639 110.155H109.791V110.197C109.876 110.282 109.939 110.388 109.918 110.494L109.727 113.208C109.706 113.569 109.6 113.781 109.536 113.866V113.908H110.194C110.109 113.781 110.088 113.505 110.109 113.293L110.3 110.706L111.657 113.929H111.742L113.12 110.706L113.29 113.314C113.311 113.526 113.29 113.781 113.205 113.929H114.032ZM118.527 113.887V113.929H117.637C117.658 113.696 117.594 113.463 117.509 113.251L117.17 112.424H115.877L115.537 113.251C115.431 113.484 115.389 113.717 115.41 113.929H114.71V113.887L114.719 113.879C114.864 113.755 114.988 113.649 115.113 113.399L116.279 110.643C116.343 110.494 116.343 110.325 116.258 110.219V110.176H116.788L118.145 113.399C118.25 113.649 118.374 113.756 118.519 113.88L118.527 113.887ZM117.022 112.106L116.513 110.897L116.004 112.106H117.022ZM120.075 110.155H119.312V110.197C119.375 110.282 119.418 110.388 119.418 110.494V113.59C119.418 113.696 119.375 113.802 119.312 113.887V113.929H120.075V113.887C120.012 113.802 119.969 113.696 119.969 113.59V110.494C119.969 110.388 120.012 110.282 120.075 110.197V110.155ZM124.57 110.155V110.197C124.507 110.282 124.464 110.388 124.464 110.494V113.929H124.38L121.665 110.94V113.293C121.665 113.505 121.708 113.781 121.793 113.908H121.178V113.866C121.241 113.781 121.284 113.675 121.284 113.569V110.643C121.284 110.452 121.178 110.282 121.072 110.197V110.155H121.687L124.104 112.827V110.77C124.104 110.558 124.061 110.282 123.977 110.155H124.57ZM114.858 116.728L115.007 116.198L114.985 116.177L114.985 116.177C114.922 116.198 114.858 116.219 114.773 116.219H112.377C112.292 116.219 112.229 116.198 112.165 116.177H112.144L111.932 116.749L111.974 116.771C112.123 116.622 112.271 116.58 112.504 116.58H113.204V119.654C113.204 119.76 113.162 119.866 113.077 119.951V119.994H113.862V119.951C113.777 119.866 113.734 119.76 113.734 119.654V116.58H114.392C114.604 116.58 114.752 116.622 114.837 116.728H114.858ZM118.866 119.951V119.994H117.975C117.997 119.76 117.933 119.527 117.848 119.315L117.509 118.488H116.215L115.876 119.315C115.77 119.548 115.728 119.782 115.749 119.994H115.049V119.951L115.058 119.944L115.058 119.944C115.203 119.82 115.327 119.713 115.452 119.464L116.618 116.707C116.682 116.559 116.682 116.389 116.597 116.283V116.24H117.127L118.484 119.464C118.588 119.714 118.713 119.82 118.858 119.945L118.866 119.951ZM117.36 118.17L116.852 116.961L116.343 118.17H117.36ZM120.669 120.057C121.729 120.057 122.174 119.464 122.174 118.87C122.174 118.213 121.602 117.894 121.305 117.831C121.623 117.682 121.792 117.386 121.792 117.046C121.792 116.559 121.432 116.156 120.52 116.156C120.285 116.156 120.003 116.179 119.752 116.2C119.664 116.207 119.58 116.214 119.502 116.219V116.262C119.566 116.347 119.608 116.453 119.608 116.559V119.654C119.608 119.761 119.566 119.867 119.502 119.951V119.994C119.556 119.997 119.616 120.002 119.681 120.006C119.999 120.028 120.422 120.057 120.669 120.057ZM120.138 116.516C120.244 116.495 120.35 116.495 120.435 116.495C121.05 116.495 121.283 116.728 121.283 117.152C121.283 117.47 121.177 117.788 120.266 117.788H120.138V116.516ZM120.541 118.085C121.305 118.085 121.623 118.382 121.623 118.912C121.623 119.294 121.453 119.697 120.626 119.718C120.499 119.718 120.308 119.697 120.138 119.676V118.107C120.175 118.107 120.227 118.103 120.287 118.098C120.365 118.092 120.457 118.085 120.541 118.085Z" fill="white"/>
 * </g>
 * <ellipse id="Ellipse 1" cx="120.5" cy="150" rx="21.5" ry="5" fill="#E6E6E6"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="234" height="329" viewBox="0 0 234 329" fill="none">
 * <g id="state=down">
 * <g id="Logo">
 * <circle id="Background" cx="117" cy="115" r="25" fill="#2C4B46"/>
 * <path id="LogoText" fill-rule="evenodd" clip-rule="evenodd" d="M95.733 115.063C95.733 103.283 105.283 93.7327 117.064 93.7327C128.844 93.7327 138.394 103.283 138.394 115.063C138.394 126.844 128.844 136.394 117.064 136.394C105.283 136.394 95.733 126.844 95.733 115.063ZM117.064 92.7966C104.766 92.7966 94.7969 102.766 94.7969 115.063C94.7969 127.361 104.766 137.33 117.064 137.33C129.361 137.33 139.33 127.361 139.33 115.063C139.33 102.766 129.361 92.7966 117.064 92.7966ZM101.813 115.063C101.813 106.64 108.641 99.8124 117.063 99.8124C125.486 99.8124 132.314 106.64 132.314 115.063C132.314 123.486 125.486 130.314 117.063 130.314C108.641 130.314 101.813 123.486 101.813 115.063ZM117.063 99.1428C108.271 99.1428 101.143 106.271 101.143 115.063C101.143 123.856 108.271 130.983 117.063 130.983C125.856 130.983 132.984 123.856 132.984 115.063C132.984 106.271 125.856 99.1428 117.063 99.1428ZM102.623 101.789L102.793 101.598L103.514 101.916L103.174 101.195L103.344 101.004L103.747 101.895L104.616 102.234L103.832 100.474L104.044 100.262L104.934 102.361L104.807 102.552L103.789 102.171L104.213 103.167L104.044 103.337L101.923 102.51L102.114 102.298L103.895 103.04L103.535 102.171L102.623 101.789ZM108.37 99.8594L107.224 98.0782L106.991 98.2266L107.479 98.99L106.504 99.6049L106.016 98.8415L105.783 98.99L106.928 100.75L107.161 100.623L106.652 99.817L107.627 99.202L108.136 100.008L108.37 99.8594ZM110.872 98.693C110.723 98.7355 110.596 98.7567 110.469 98.7567C110.342 98.7355 110.214 98.7142 110.087 98.6506C109.96 98.587 109.875 98.5022 109.769 98.3962C109.684 98.2902 109.621 98.1841 109.557 98.0569C109.515 97.9297 109.493 97.7812 109.493 97.654C109.493 97.5268 109.515 97.3783 109.578 97.2511C109.621 97.1239 109.706 97.0179 109.79 96.9118C109.875 96.8058 110.002 96.7422 110.13 96.6998C110.278 96.6574 110.405 96.6362 110.533 96.6362C110.66 96.6574 110.787 96.6998 110.914 96.7634C111.041 96.827 111.126 96.9118 111.232 97.0179C111.317 97.1239 111.381 97.2299 111.444 97.3571C111.487 97.4844 111.508 97.6328 111.508 97.76C111.508 97.8873 111.487 98.0357 111.423 98.1629C111.381 98.2902 111.296 98.3962 111.211 98.5022C111.126 98.6082 110.999 98.6506 110.872 98.693ZM109.812 97.9509C109.854 98.0569 109.896 98.1417 109.96 98.2265C110.024 98.3114 110.108 98.375 110.193 98.4174C110.278 98.4598 110.363 98.5022 110.469 98.5022C110.575 98.5234 110.66 98.5022 110.766 98.4598C110.872 98.4174 110.957 98.3538 111.02 98.2902C111.084 98.2053 111.126 98.1205 111.169 98.0357C111.211 97.9509 111.211 97.8449 111.211 97.7388C111.211 97.6328 111.19 97.5268 111.147 97.442C111.105 97.3359 111.063 97.2511 110.999 97.1663C110.935 97.0815 110.851 97.0179 110.766 96.9755C110.681 96.933 110.575 96.8906 110.49 96.8906C110.384 96.8906 110.299 96.8906 110.193 96.933C110.087 96.9755 110.002 97.0391 109.939 97.1027C109.875 97.1875 109.833 97.2723 109.79 97.3571L109.79 97.3571L109.781 97.4023C109.763 97.4884 109.748 97.5634 109.748 97.654L109.748 97.6541C109.769 97.7601 109.79 97.8661 109.812 97.9509ZM113.204 95.8302L113.544 97.9083L114.986 97.675L114.943 97.4418L113.777 97.6326L113.459 95.7878L113.204 95.8302ZM118.103 97.336V97.5692L116.682 97.548L116.724 95.4488L118.124 95.47V95.7032L116.979 95.682V96.3606L117.975 96.3818V96.5938L116.979 96.5726L116.958 97.2936L118.103 97.336ZM121.219 96.212C121.304 96.2756 121.368 96.3392 121.41 96.4028L121.601 96.2544C121.516 96.1696 121.431 96.0847 121.325 96.0211C121.219 95.9575 121.092 95.8939 120.965 95.8727C120.816 95.8515 120.689 95.8515 120.562 95.8727C120.456 95.8939 120.35 95.9363 120.265 96.0211C120.18 96.1059 120.117 96.212 120.095 96.3392C120.074 96.4452 120.074 96.53 120.117 96.6149C120.159 96.6997 120.223 96.7633 120.307 96.8269L120.308 96.8269C120.414 96.8905 120.52 96.9541 120.647 97.0178C120.719 97.0467 120.792 97.0856 120.857 97.1209L120.857 97.1209C120.888 97.1372 120.917 97.1528 120.944 97.1662C121.007 97.2086 121.071 97.251 121.113 97.3146C121.134 97.357 121.156 97.4206 121.134 97.5055C121.113 97.6115 121.05 97.6751 120.965 97.7175C120.88 97.7599 120.753 97.7599 120.604 97.7387C120.498 97.7175 120.392 97.6751 120.307 97.6327C120.223 97.5903 120.138 97.5479 120.074 97.4843C120.039 97.4492 120.011 97.4142 119.985 97.3827L119.985 97.3827L119.985 97.3827L119.985 97.3827L119.985 97.3827C119.964 97.357 119.945 97.3337 119.926 97.3146L119.756 97.5055C119.968 97.7599 120.223 97.9084 120.541 97.972C120.689 98.0144 120.816 98.0144 120.944 97.9932C121.05 97.9932 121.156 97.9296 121.241 97.8659C121.325 97.8023 121.389 97.6963 121.41 97.5691C121.431 97.4418 121.431 97.3358 121.389 97.251C121.347 97.1662 121.283 97.0814 121.177 97.0178C121.092 96.9541 120.965 96.8905 120.838 96.8269L120.541 96.6785C120.477 96.6361 120.414 96.5724 120.392 96.53C120.371 96.4664 120.35 96.4028 120.371 96.3392C120.392 96.2332 120.456 96.1484 120.541 96.1059C120.626 96.0635 120.732 96.0423 120.901 96.0847C121.028 96.1059 121.134 96.1484 121.219 96.212ZM124.337 96.8693L124.549 96.9541V99.2231L124.294 99.117V98.4597L123.467 98.1204L123.001 98.6081L122.746 98.5021L124.337 96.8693ZM124.316 98.2264L124.337 97.1874L123.616 97.9508L124.316 98.2264ZM127.2 98.2903L126.055 100.05L127.264 100.835L127.391 100.644L126.415 100.008L127.433 98.4387L127.2 98.2903ZM129.786 102.722L129.616 102.892L128.577 101.895L130.041 100.368L131.058 101.344L130.889 101.513L130.062 100.729L129.595 101.216L130.316 101.895L130.168 102.065L129.447 101.386L128.938 101.916L129.786 102.722ZM99.6969 124.626L101.075 123.799L100.333 125.729L100.46 125.941L102.263 124.859L102.135 124.605L100.715 125.453L101.478 123.502L101.372 123.312L99.5696 124.393L99.6969 124.626ZM102.941 128.655L102.771 128.804L101.817 127.743L103.386 126.344L104.319 127.383L104.149 127.531L103.386 126.683L102.877 127.128L103.534 127.871L103.365 128.019L102.707 127.277L102.156 127.765L102.941 128.655ZM106.397 129.207L106.185 129.058L105.952 130.012L105.146 130.5L105.634 128.634L105.401 128.464L104.87 130.691L105.061 130.818L105.994 130.267L105.74 131.327L105.931 131.454L107.882 130.267L107.648 130.097L106.015 131.136L106.228 130.224L107.055 129.694L106.842 129.546L106.185 129.97L106.397 129.207ZM111.19 131.793L111.465 133.023L112.398 132.154L112.674 132.239L111.508 133.278L111.275 134.02L111.02 133.935L111.253 133.193L110.893 131.687L111.19 131.793ZM114.412 134.635C114.518 134.699 114.646 134.741 114.794 134.762C114.943 134.783 115.07 134.762 115.197 134.72C115.324 134.677 115.43 134.614 115.536 134.529C115.642 134.444 115.727 134.338 115.791 134.211C115.854 134.105 115.897 133.978 115.918 133.829C115.939 133.681 115.939 133.554 115.897 133.426C115.854 133.299 115.812 133.172 115.727 133.066C115.663 132.96 115.557 132.875 115.451 132.79C115.345 132.727 115.218 132.684 115.07 132.663C114.921 132.642 114.794 132.663 114.667 132.705C114.54 132.748 114.434 132.811 114.328 132.896C114.222 132.981 114.137 133.087 114.073 133.214C114.009 133.32 113.967 133.448 113.946 133.596C113.925 133.723 113.925 133.872 113.967 133.999C114.009 134.126 114.052 134.253 114.137 134.359C114.2 134.465 114.306 134.571 114.412 134.635ZM114.222 133.935C114.2 133.829 114.179 133.723 114.2 133.617C114.222 133.511 114.243 133.426 114.285 133.32C114.328 133.214 114.391 133.129 114.455 133.066C114.54 132.981 114.624 132.939 114.709 132.896C114.815 132.854 114.921 132.833 115.027 132.854C115.133 132.875 115.218 132.896 115.303 132.96C115.388 133.023 115.451 133.087 115.515 133.172C115.579 133.257 115.621 133.342 115.642 133.448C115.663 133.554 115.685 133.66 115.663 133.766L115.663 133.766C115.642 133.872 115.621 133.978 115.579 134.063C115.536 134.169 115.473 134.253 115.409 134.317C115.324 134.402 115.239 134.444 115.155 134.487C115.049 134.529 114.943 134.55 114.836 134.529C114.709 134.508 114.624 134.487 114.54 134.423C114.455 134.359 114.391 134.296 114.328 134.211C114.285 134.126 114.243 134.041 114.222 133.935ZM117.933 134.868L117.763 132.769L118.654 132.705C118.738 132.705 118.823 132.705 118.908 132.748C118.993 132.79 119.057 132.833 119.12 132.875C119.184 132.939 119.226 133.002 119.269 133.087C119.311 133.172 119.332 133.235 119.332 133.32C119.332 133.426 119.332 133.511 119.29 133.596C119.271 133.669 119.222 133.742 119.181 133.802L119.163 133.829C119.099 133.893 119.035 133.935 118.95 133.978L119.523 134.741L119.226 134.762L118.696 134.041L118.145 134.084L118.208 134.847L117.933 134.868ZM118.102 133.85L118.738 133.808C118.802 133.808 118.866 133.787 118.929 133.723C118.972 133.681 119.014 133.617 119.035 133.554C119.057 133.49 119.078 133.405 119.056 133.342C119.056 133.257 119.035 133.193 118.993 133.129C118.95 133.066 118.908 133.023 118.844 132.981C118.781 132.939 118.717 132.939 118.654 132.939L118.039 132.981L118.102 133.85ZM121.05 132.324L121.601 134.359L121.835 134.274L121.665 133.659L121.92 133.214L122.916 133.999L123.213 133.914L122.047 133.002L122.619 131.878L122.344 131.963L121.601 133.384L121.305 132.26L121.05 132.324ZM126.521 131.263C126.457 131.157 126.393 131.03 126.372 130.903C126.351 130.776 126.33 130.648 126.351 130.521C126.372 130.394 126.415 130.267 126.478 130.14C126.539 130.018 126.639 129.935 126.758 129.835L126.758 129.835L126.758 129.835L126.775 129.821C126.923 129.715 127.093 129.673 127.241 129.673C127.411 129.673 127.538 129.715 127.666 129.779L127.56 130.012C127.475 129.97 127.39 129.927 127.305 129.927C127.22 129.927 127.135 129.927 127.072 129.949C126.987 129.97 126.923 129.991 126.881 130.033C126.775 130.097 126.711 130.182 126.669 130.267C126.627 130.352 126.584 130.458 126.584 130.542C126.584 130.648 126.584 130.733 126.605 130.839C126.627 130.945 126.669 131.03 126.733 131.115C126.796 131.2 126.86 131.285 126.945 131.348C127.029 131.412 127.114 131.454 127.22 131.497L127.247 131.502C127.341 131.521 127.42 131.537 127.517 131.518C127.623 131.518 127.708 131.475 127.793 131.412C127.856 131.369 127.92 131.327 127.962 131.263C128.005 131.2 128.047 131.136 128.068 131.051C128.09 130.967 128.111 130.882 128.09 130.776L128.344 130.754C128.365 130.86 128.365 130.988 128.323 131.094C128.281 131.2 128.238 131.306 128.153 131.391C128.09 131.475 128.005 131.56 127.899 131.624C127.772 131.709 127.644 131.751 127.517 131.772C127.39 131.793 127.241 131.772 127.114 131.73C126.987 131.687 126.86 131.624 126.754 131.539C126.669 131.475 126.584 131.369 126.521 131.263ZM128.789 128.295L130.21 129.864L130.401 129.694L128.98 128.125L128.789 128.295ZM131.482 125.75L131.016 126.323L132.458 127.51L132.288 127.722L130.846 126.535L130.38 127.107L130.189 126.959L131.27 125.623L131.482 125.75ZM133.539 124.117L132.267 124.138L132.14 124.393L133.688 124.329L134.366 124.711L134.494 124.478L133.815 124.117L133.031 122.76L132.882 123.015L133.539 124.117ZM114.858 107.048L114.71 107.578H114.689C114.604 107.472 114.455 107.429 114.243 107.429H113.586V110.504C113.586 110.61 113.628 110.716 113.713 110.801V110.865H112.929V110.822C113.013 110.737 113.056 110.631 113.056 110.525V107.451H112.356C112.123 107.451 111.974 107.493 111.826 107.641L111.784 107.62L111.996 107.048H112.017C112.08 107.069 112.144 107.09 112.229 107.09H114.646C114.731 107.09 114.795 107.069 114.858 107.048ZM118.802 110.525V107.429C118.802 107.323 118.845 107.217 118.908 107.133V107.09H118.145C118.23 107.217 118.272 107.493 118.272 107.705V108.532H116.343V107.705C116.343 107.493 116.385 107.239 116.47 107.09H115.706V107.133C115.77 107.217 115.812 107.323 115.812 107.429V110.504C115.812 110.61 115.77 110.716 115.706 110.801V110.843H116.47C116.385 110.716 116.343 110.441 116.343 110.228V108.893H118.272V110.25C118.272 110.462 118.23 110.716 118.145 110.865H118.908V110.822C118.845 110.737 118.802 110.631 118.802 110.525ZM122.323 110.186L122.089 110.886C122.026 110.865 121.962 110.844 121.877 110.844H119.948V110.801C120.011 110.716 120.054 110.61 120.054 110.504V107.43C120.054 107.324 120.011 107.218 119.948 107.133V107.09H121.729C121.835 107.09 121.941 107.09 122.026 107.048H122.047V107.748H122.026C121.92 107.514 121.814 107.43 121.496 107.43H120.584V108.532H121.474C121.559 108.532 121.623 108.511 121.665 108.469H121.686V108.978H121.665C121.559 108.914 121.453 108.872 121.347 108.872H120.584V110.504H121.58C121.962 110.504 122.153 110.335 122.301 110.165L122.323 110.186ZM114.032 116.929V116.887C113.968 116.802 113.862 116.59 113.841 116.208L113.65 113.494C113.629 113.388 113.693 113.282 113.777 113.197V113.155H112.972L111.784 115.89L110.639 113.155H109.791V113.197C109.876 113.282 109.939 113.388 109.918 113.494L109.727 116.208C109.706 116.569 109.6 116.781 109.536 116.866V116.908H110.194C110.109 116.781 110.088 116.505 110.109 116.293L110.3 113.706L111.657 116.929H111.742L113.12 113.706L113.29 116.314C113.311 116.526 113.29 116.781 113.205 116.929H114.032ZM118.527 116.887V116.929H117.637C117.658 116.696 117.594 116.463 117.509 116.251L117.17 115.424H115.877L115.537 116.251C115.431 116.484 115.389 116.717 115.41 116.929H114.71V116.887L114.719 116.879C114.864 116.755 114.988 116.649 115.113 116.399L116.279 113.643C116.343 113.494 116.343 113.325 116.258 113.219V113.176H116.788L118.145 116.399C118.25 116.649 118.374 116.756 118.519 116.88L118.527 116.887ZM117.022 115.106L116.513 113.897L116.004 115.106H117.022ZM120.075 113.155H119.312V113.197C119.375 113.282 119.418 113.388 119.418 113.494V116.59C119.418 116.696 119.375 116.802 119.312 116.887V116.929H120.075V116.887C120.012 116.802 119.969 116.696 119.969 116.59V113.494C119.969 113.388 120.012 113.282 120.075 113.197V113.155ZM124.57 113.155V113.197C124.507 113.282 124.464 113.388 124.464 113.494V116.929H124.38L121.665 113.94V116.293C121.665 116.505 121.708 116.781 121.793 116.908H121.178V116.866C121.241 116.781 121.284 116.675 121.284 116.569V113.643C121.284 113.452 121.178 113.282 121.072 113.197V113.155H121.687L124.104 115.827V113.77C124.104 113.558 124.061 113.282 123.977 113.155H124.57ZM114.858 119.728L115.007 119.198L114.985 119.177L114.985 119.177C114.922 119.198 114.858 119.219 114.773 119.219H112.377C112.292 119.219 112.229 119.198 112.165 119.177H112.144L111.932 119.749L111.974 119.771C112.123 119.622 112.271 119.58 112.504 119.58H113.204V122.654C113.204 122.76 113.162 122.866 113.077 122.951V122.994H113.862V122.951C113.777 122.866 113.734 122.76 113.734 122.654V119.58H114.392C114.604 119.58 114.752 119.622 114.837 119.728H114.858ZM118.866 122.951V122.994H117.975C117.997 122.76 117.933 122.527 117.848 122.315L117.509 121.488H116.215L115.876 122.315C115.77 122.548 115.728 122.782 115.749 122.994H115.049V122.951L115.058 122.944L115.058 122.944C115.203 122.82 115.327 122.713 115.452 122.464L116.618 119.707C116.682 119.559 116.682 119.389 116.597 119.283V119.24H117.127L118.484 122.464C118.588 122.714 118.713 122.82 118.858 122.945L118.866 122.951ZM117.36 121.17L116.852 119.961L116.343 121.17H117.36ZM120.669 123.057C121.729 123.057 122.174 122.464 122.174 121.87C122.174 121.213 121.602 120.894 121.305 120.831C121.623 120.682 121.792 120.386 121.792 120.046C121.792 119.559 121.432 119.156 120.52 119.156C120.285 119.156 120.003 119.179 119.752 119.2C119.664 119.207 119.58 119.214 119.502 119.219V119.262C119.566 119.347 119.608 119.453 119.608 119.559V122.654C119.608 122.761 119.566 122.867 119.502 122.951V122.994C119.556 122.997 119.616 123.002 119.681 123.006C119.999 123.028 120.422 123.057 120.669 123.057ZM120.138 119.516C120.244 119.495 120.35 119.495 120.435 119.495C121.05 119.495 121.283 119.728 121.283 120.152C121.283 120.47 121.177 120.788 120.266 120.788H120.138V119.516ZM120.541 121.085C121.305 121.085 121.623 121.382 121.623 121.912C121.623 122.294 121.453 122.697 120.626 122.718C120.499 122.718 120.308 122.697 120.138 122.676V121.107C120.175 121.107 120.227 121.103 120.287 121.098C120.365 121.092 120.457 121.085 120.541 121.085Z" fill="white"/>
 * </g>
 * <ellipse id="Ellipse 1" cx="121" cy="151" rx="23" ry="6" fill="#E6E6E6"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#LoadingImage": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 538,
 * 		"height": 369
 * 	},
 * 	"#state_3Dup": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 234,
 * 		"height": 329
 * 	},
 * 	"#Logo": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 50.00025177001953,
 * 		"height": 50.00001525878906
 * 	},
 * 	"#Background": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 50,
 * 		"height": 50
 * 	},
 * 	"#LogoText": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 44.53328323364258,
 * 		"height": 44.53328323364258
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 2.6718084812164307,
 * 		"height": 3.901681900024414
 * 	},
 * 	"#Ellipse_201": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 46,
 * 		"height": 12
 * 	},
 * 	"#state_3Ddown": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 234,
 * 		"height": 329
 * 	},
 * 	"transforms": {
 * 		"Logo": [
 * 			{
 * 				"name": "Logo",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-5.551115123125783e-17,
 * 						92
 * 					],
 * 					[
 * 						5.551115123125783e-17,
 * 						1,
 * 						87
 * 					]
 * 				],
 * 				"rotation": -3.1805546814635168e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 50.00025177001953,
 * 				"height": 50.00001525878906
 * 			},
 * 			{
 * 				"name": "Logo",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-5.551115123125783e-17,
 * 						92
 * 					],
 * 					[
 * 						5.551115123125783e-17,
 * 						1,
 * 						90
 * 					]
 * 				],
 * 				"rotation": -3.1805546814635168e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 50.00025177001953,
 * 				"height": 50.00001525878906
 * 			}
 * 		],
 * 		"Background": [
 * 			{
 * 				"name": "Background",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						5.551115123125783e-17,
 * 						0.00025022029876708984
 * 					],
 * 					[
 * 						-5.551115123125783e-17,
 * 						1,
 * 						0.000014066696166992188
 * 					]
 * 				],
 * 				"rotation": 3.1805546814635168e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 50,
 * 				"height": 50
 * 			},
 * 			{
 * 				"name": "Background",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						5.551115123125783e-17,
 * 						0.00025022029876708984
 * 					],
 * 					[
 * 						-5.551115123125783e-17,
 * 						1,
 * 						0.000014066696166992188
 * 					]
 * 				],
 * 				"rotation": 3.1805546814635168e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 50,
 * 				"height": 50
 * 			}
 * 		],
 * 		"LogoText": [
 * 			{
 * 				"name": "LogoText",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						2.7965633869171143
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						2.7965939044952393
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 44.53328323364258,
 * 				"height": 44.53328323364258
 * 			},
 * 			{
 * 				"name": "LogoText",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						2.7965633869171143
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						2.7965939044952393
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 44.53328323364258,
 * 				"height": 44.53328323364258
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-1.1859199768411092e-16,
 * 						3.2646484971046448
 * 					],
 * 					[
 * 						1.1859199768411092e-16,
 * 						1,
 * 						3.2646790146827698
 * 					]
 * 				],
 * 				"rotation": -6.794820951324789e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 43.597110748291016,
 * 				"height": 43.597110748291016
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-2.3718399536822184e-16,
 * 						9.477539300918579
 * 					],
 * 					[
 * 						2.3718399536822184e-16,
 * 						1,
 * 						9.477630853652954
 * 					]
 * 				],
 * 				"rotation": -1.3589641902649577e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 31.171092987060547,
 * 				"height": 31.171092987060547
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						9.922851800918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						10.262207269668579
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.011082887649536,
 * 				"height": 3.0746989250183105
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						13.782226800918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						8.078186273574829
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.586989641189575,
 * 				"height": 2.6718058586120605
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						17.49316430091858
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						6.636199951171875
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0144548416137695,
 * 				"height": 2.1204822063446045
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						21.204100847244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.787841796875
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.7812068462371826,
 * 				"height": 2.120481491088867
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						24.681639909744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.44879150390625
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.4419262409210205,
 * 				"height": 2.120481252670288
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						27.755858659744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.8568115234375
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.8448207378387451,
 * 				"height": 2.150313377380371
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						30.746093034744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						6.869354486465454
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.8024108409881592,
 * 				"height": 2.3537354469299316
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						34.05468678474426
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						8.290313959121704
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.3783069849014282,
 * 				"height": 2.5445775985717773
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						36.577149629592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						10.368194818496704
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.48095965385437,
 * 				"height": 2.5233747959136963
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						7.569336175918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						33.31155323982239
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.693009853363037,
 * 				"height": 2.6294004917144775
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						9.816406488418579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						36.34390377998352
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.5021708011627197,
 * 				"height": 2.459760904312134
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						12.870117425918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						38.464478731155396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0110890865325928,
 * 				"height": 2.9898886680603027
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						18.892577409744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						41.687379121780396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.781203269958496,
 * 				"height": 2.332533121109009
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						21.931639909744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						42.65469479560852
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.9999092817306519,
 * 				"height": 2.1159110069274902
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						25.762694597244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						42.705384492874146
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.7600010633468628,
 * 				"height": 2.162886619567871
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						29.049803972244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						41.87826657295227
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.162893772125244,
 * 				"height": 2.48095965385437
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						34.34179615974426
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						39.673035860061646
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0159671306610107,
 * 				"height": 2.107593536376953
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						36.789063692092896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						38.125123262405396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.6115673780441284,
 * 				"height": 1.7387951612472534
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						38.188477754592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						35.62295651435852
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.2689156532287598,
 * 				"height": 2.099283456802368
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						40.139649629592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						32.76019215583801
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.353739023208618,
 * 				"height": 1.9508445262908936
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						19.783202409744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						17.047760248184204
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0746994018554688,
 * 				"height": 3.8168673515319824
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						23.706053972244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						17.090179681777954
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.2019307613372803,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.947264909744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						17.04797387123108
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.3749520778656006,
 * 				"height": 3.8380696773529053
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						17.53613305091858
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						23.154906511306763
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 4.495420932769775,
 * 				"height": 3.774454116821289
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						22.709960222244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.176177263259888
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.8168673515319824,
 * 				"height": 3.7532553672790527
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.311522722244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.154937028884888
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 0.7633774280548096,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						29.071288347244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.155028581619263
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.4987871646881104,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						19.931639909744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.176818132400513
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0746994018554688,
 * 				"height": 3.816870927810669
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						23.048827409744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.240508317947388
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.816870927810669,
 * 				"height": 3.7532553672790527
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.501952409744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.155730485916138
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.6718084812164307,
 * 				"height": 3.901681900024414
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-1.1859199768411092e-16,
 * 						3.2646484971046448
 * 					],
 * 					[
 * 						1.1859199768411092e-16,
 * 						1,
 * 						3.2646790146827698
 * 					]
 * 				],
 * 				"rotation": -6.794820951324789e-15,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 43.597110748291016,
 * 				"height": 43.597110748291016
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-2.3718399536822184e-16,
 * 						9.477539300918579
 * 					],
 * 					[
 * 						2.3718399536822184e-16,
 * 						1,
 * 						9.477630853652954
 * 					]
 * 				],
 * 				"rotation": -1.3589641902649577e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 31.171092987060547,
 * 				"height": 31.171092987060547
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						9.922851800918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						10.262207269668579
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.011082887649536,
 * 				"height": 3.0746989250183105
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						13.782226800918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						8.078186273574829
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.586989641189575,
 * 				"height": 2.6718058586120605
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						17.49316430091858
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						6.636199951171875
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0144548416137695,
 * 				"height": 2.1204822063446045
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						21.204100847244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.787841796875
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.7812068462371826,
 * 				"height": 2.120481491088867
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						24.681639909744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.44879150390625
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.4419262409210205,
 * 				"height": 2.120481252670288
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						27.755858659744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						5.8568115234375
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.8448207378387451,
 * 				"height": 2.150313377380371
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						30.746093034744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						6.869354486465454
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.8024108409881592,
 * 				"height": 2.3537354469299316
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						34.05468678474426
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						8.290313959121704
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.3783069849014282,
 * 				"height": 2.5445775985717773
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						36.577149629592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						10.368194818496704
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.48095965385437,
 * 				"height": 2.5233747959136963
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						7.569336175918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						33.31155323982239
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.693009853363037,
 * 				"height": 2.6294004917144775
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						9.816406488418579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						36.34390377998352
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.5021708011627197,
 * 				"height": 2.459760904312134
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						12.870117425918579
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						38.464478731155396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0110890865325928,
 * 				"height": 2.9898886680603027
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						18.892577409744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						41.687379121780396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.781203269958496,
 * 				"height": 2.332533121109009
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						21.931639909744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						42.65469479560852
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.9999092817306519,
 * 				"height": 2.1159110069274902
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						25.762694597244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						42.705384492874146
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.7600010633468628,
 * 				"height": 2.162886619567871
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						29.049803972244263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						41.87826657295227
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.162893772125244,
 * 				"height": 2.48095965385437
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						34.34179615974426
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						39.673035860061646
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0159671306610107,
 * 				"height": 2.107593536376953
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						36.789063692092896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						38.125123262405396
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 1.6115673780441284,
 * 				"height": 1.7387951612472534
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						38.188477754592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						35.62295651435852
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.2689156532287598,
 * 				"height": 2.099283456802368
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						40.139649629592896
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						32.76019215583801
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.353739023208618,
 * 				"height": 1.9508445262908936
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						19.783202409744263
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						17.047760248184204
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0746994018554688,
 * 				"height": 3.8168673515319824
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						23.706053972244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						17.090179681777954
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.2019307613372803,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.947264909744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						17.04797387123108
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.3749520778656006,
 * 				"height": 3.8380696773529053
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-3.5577599305233276e-16,
 * 						17.53613305091858
 * 					],
 * 					[
 * 						3.5577599305233276e-16,
 * 						1,
 * 						23.154906511306763
 * 					]
 * 				],
 * 				"rotation": -2.0384462853974367e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 4.495420932769775,
 * 				"height": 3.774454116821289
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						22.709960222244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.176177263259888
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.8168673515319824,
 * 				"height": 3.7532553672790527
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.311522722244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.154937028884888
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 0.7633774280548096,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						29.071288347244263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						23.155028581619263
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.4987871646881104,
 * 				"height": 3.7744557857513428
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						19.931639909744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.176818132400513
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.0746994018554688,
 * 				"height": 3.816870927810669
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						23.048827409744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.240508317947388
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 3.816870927810669,
 * 				"height": 3.7532553672790527
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						-4.743679907364437e-16,
 * 						27.501952409744263
 * 					],
 * 					[
 * 						4.743679907364437e-16,
 * 						1,
 * 						29.155730485916138
 * 					]
 * 				],
 * 				"rotation": -2.7179283805299154e-14,
 * 				"instanceParentName": "Logo",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.6718084812164307,
 * 				"height": 3.901681900024414
 * 			}
 * 		]
 * 	},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"state=up": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"state=down": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "up" | "down";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigBackgroundd: string | number | Animated.AnimatedInterpolation;
  morphConfigLogoTextd: string | number | Animated.AnimatedInterpolation;
  morphConfigEllipse_201d: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const LoadingImage = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "up" | "down";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 234,
      height: 329,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigBackgroundd: "M142 112 A25 25 0 0 1 117 137 A25 25 0 0 1 92 112 A25 25 0 0 1 142 112z",
      morphConfigLogoTextd:
        "M95.733 112.063C95.733 100.283 105.283 90.7327 117.064 90.7327C128.844 90.7327 138.394 100.283 138.394 112.063C138.394 123.844 128.844 133.394 117.064 133.394C105.283 133.394 95.733 123.844 95.733 112.063ZM117.064 89.7966C104.766 89.7966 94.7969 99.7657 94.7969 112.063C94.7969 124.361 104.766 134.33 117.064 134.33C129.361 134.33 139.33 124.361 139.33 112.063C139.33 99.7657 129.361 89.7966 117.064 89.7966ZM101.813 112.063C101.813 103.64 108.641 96.8124 117.063 96.8124C125.486 96.8124 132.314 103.64 132.314 112.063C132.314 120.486 125.486 127.314 117.063 127.314C108.641 127.314 101.813 120.486 101.813 112.063ZM117.063 96.1428C108.271 96.1428 101.143 103.271 101.143 112.063C101.143 120.856 108.271 127.983 117.063 127.983C125.856 127.983 132.984 120.856 132.984 112.063C132.984 103.271 125.856 96.1428 117.063 96.1428ZM102.623 98.7889L102.793 98.5981L103.514 98.9162L103.174 98.1952L103.344 98.0044L103.747 98.895L104.616 99.2342L103.832 97.4742L104.044 97.2622L104.934 99.3615L104.807 99.5523L103.789 99.1706L104.213 100.167L104.044 100.337L101.923 99.5099L102.114 99.2978L103.895 100.04L103.535 99.1706L102.623 98.7889ZM108.37 96.8594L107.224 95.0782L106.991 95.2266L107.479 95.99L106.504 96.6049L106.016 95.8415L105.783 95.99L106.928 97.75L107.161 97.6227L106.652 96.817L107.627 96.202L108.136 97.0078L108.37 96.8594ZM110.872 95.693C110.723 95.7355 110.596 95.7567 110.469 95.7567C110.342 95.7355 110.214 95.7142 110.087 95.6506C109.96 95.587 109.875 95.5022 109.769 95.3962C109.684 95.2902 109.621 95.1841 109.557 95.0569C109.515 94.9297 109.493 94.7812 109.493 94.654C109.493 94.5268 109.515 94.3783 109.578 94.2511C109.621 94.1239 109.706 94.0179 109.79 93.9118C109.875 93.8058 110.002 93.7422 110.13 93.6998C110.278 93.6574 110.405 93.6362 110.533 93.6362C110.66 93.6574 110.787 93.6998 110.914 93.7634C111.041 93.827 111.126 93.9118 111.232 94.0179C111.317 94.1239 111.381 94.2299 111.444 94.3571C111.487 94.4844 111.508 94.6328 111.508 94.76C111.508 94.8873 111.487 95.0357 111.423 95.1629C111.381 95.2902 111.296 95.3962 111.211 95.5022C111.126 95.6082 110.999 95.6506 110.872 95.693ZM109.812 94.9509C109.854 95.0569 109.896 95.1417 109.96 95.2265C110.024 95.3114 110.108 95.375 110.193 95.4174C110.278 95.4598 110.363 95.5022 110.469 95.5022C110.575 95.5234 110.66 95.5022 110.766 95.4598C110.872 95.4174 110.957 95.3538 111.02 95.2902C111.084 95.2053 111.126 95.1205 111.169 95.0357C111.211 94.9509 111.211 94.8449 111.211 94.7388C111.211 94.6328 111.19 94.5268 111.147 94.442C111.105 94.3359 111.063 94.2511 110.999 94.1663C110.935 94.0815 110.851 94.0179 110.766 93.9755C110.681 93.933 110.575 93.8906 110.49 93.8906C110.384 93.8906 110.299 93.8906 110.193 93.933C110.087 93.9755 110.002 94.0391 109.939 94.1027C109.875 94.1875 109.833 94.2723 109.79 94.3571L109.79 94.3571L109.781 94.4023C109.763 94.4884 109.748 94.5634 109.748 94.654L109.748 94.6541C109.769 94.7601 109.79 94.8661 109.812 94.9509ZM113.204 92.8302L113.544 94.9083L114.986 94.675L114.943 94.4418L113.777 94.6326L113.459 92.7878L113.204 92.8302ZM118.103 94.336V94.5692L116.682 94.548L116.724 92.4488L118.124 92.47V92.7032L116.979 92.682V93.3606L117.975 93.3818V93.5938L116.979 93.5726L116.958 94.2936L118.103 94.336ZM121.219 93.212C121.304 93.2756 121.368 93.3392 121.41 93.4028L121.601 93.2544C121.516 93.1696 121.431 93.0847 121.325 93.0211C121.219 92.9575 121.092 92.8939 120.965 92.8727C120.816 92.8515 120.689 92.8515 120.562 92.8727C120.456 92.8939 120.35 92.9363 120.265 93.0211C120.18 93.1059 120.117 93.212 120.095 93.3392C120.074 93.4452 120.074 93.53 120.117 93.6149C120.159 93.6997 120.223 93.7633 120.307 93.8269L120.308 93.8269C120.414 93.8905 120.52 93.9541 120.647 94.0178C120.719 94.0467 120.792 94.0856 120.857 94.1209L120.857 94.1209C120.888 94.1372 120.917 94.1528 120.944 94.1662C121.007 94.2086 121.071 94.251 121.113 94.3146C121.134 94.357 121.156 94.4206 121.134 94.5055C121.113 94.6115 121.05 94.6751 120.965 94.7175C120.88 94.7599 120.753 94.7599 120.604 94.7387C120.498 94.7175 120.392 94.6751 120.307 94.6327C120.223 94.5903 120.138 94.5479 120.074 94.4843C120.039 94.4492 120.011 94.4142 119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827C119.964 94.357 119.945 94.3337 119.926 94.3146L119.756 94.5055C119.968 94.7599 120.223 94.9084 120.541 94.972C120.689 95.0144 120.816 95.0144 120.944 94.9932C121.05 94.9932 121.156 94.9296 121.241 94.8659C121.325 94.8023 121.389 94.6963 121.41 94.5691C121.431 94.4418 121.431 94.3358 121.389 94.251C121.347 94.1662 121.283 94.0814 121.177 94.0178C121.092 93.9541 120.965 93.8905 120.838 93.8269L120.541 93.6785C120.477 93.6361 120.414 93.5724 120.392 93.53C120.371 93.4664 120.35 93.4028 120.371 93.3392C120.392 93.2332 120.456 93.1484 120.541 93.1059C120.626 93.0635 120.732 93.0423 120.901 93.0847C121.028 93.1059 121.134 93.1484 121.219 93.212ZM124.337 93.8693L124.549 93.9541V96.2231L124.294 96.117V95.4597L123.467 95.1204L123.001 95.6081L122.746 95.5021L124.337 93.8693ZM124.316 95.2264L124.337 94.1874L123.616 94.9508L124.316 95.2264ZM127.2 95.2903L126.055 97.0503L127.264 97.8349L127.391 97.644L126.415 97.0079L127.433 95.4387L127.2 95.2903ZM129.786 99.7219L129.616 99.8915L128.577 98.8949L130.041 97.3682L131.058 98.3436L130.889 98.5132L130.062 97.7287L129.595 98.2164L130.316 98.8949L130.168 99.0646L129.447 98.386L128.938 98.9161L129.786 99.7219ZM99.6969 121.626L101.075 120.799L100.333 122.729L100.46 122.941L102.263 121.859L102.135 121.605L100.715 122.453L101.478 120.502L101.372 120.312L99.5696 121.393L99.6969 121.626ZM102.941 125.655L102.771 125.804L101.817 124.743L103.386 123.344L104.319 124.383L104.149 124.531L103.386 123.683L102.877 124.128L103.534 124.871L103.365 125.019L102.707 124.277L102.156 124.765L102.941 125.655ZM106.397 126.207L106.185 126.058L105.952 127.012L105.146 127.5L105.634 125.634L105.401 125.464L104.87 127.691L105.061 127.818L105.994 127.267L105.74 128.327L105.931 128.454L107.882 127.267L107.648 127.097L106.015 128.136L106.228 127.224L107.055 126.694L106.842 126.546L106.185 126.97L106.397 126.207ZM111.19 128.793L111.465 130.023L112.398 129.154L112.674 129.239L111.508 130.278L111.275 131.02L111.02 130.935L111.253 130.193L110.893 128.687L111.19 128.793ZM114.412 131.635C114.518 131.699 114.646 131.741 114.794 131.762C114.943 131.783 115.07 131.762 115.197 131.72C115.324 131.677 115.43 131.614 115.536 131.529C115.642 131.444 115.727 131.338 115.791 131.211C115.854 131.105 115.897 130.978 115.918 130.829C115.939 130.681 115.939 130.554 115.897 130.426C115.854 130.299 115.812 130.172 115.727 130.066C115.663 129.96 115.557 129.875 115.451 129.79C115.345 129.727 115.218 129.684 115.07 129.663C114.921 129.642 114.794 129.663 114.667 129.705C114.54 129.748 114.434 129.811 114.328 129.896C114.222 129.981 114.137 130.087 114.073 130.214C114.009 130.32 113.967 130.448 113.946 130.596C113.925 130.723 113.925 130.872 113.967 130.999C114.009 131.126 114.052 131.253 114.137 131.359C114.2 131.465 114.306 131.571 114.412 131.635ZM114.222 130.935C114.2 130.829 114.179 130.723 114.2 130.617C114.222 130.511 114.243 130.426 114.285 130.32C114.328 130.214 114.391 130.129 114.455 130.066C114.54 129.981 114.624 129.939 114.709 129.896C114.815 129.854 114.921 129.833 115.027 129.854C115.133 129.875 115.218 129.896 115.303 129.96C115.388 130.023 115.451 130.087 115.515 130.172C115.579 130.257 115.621 130.342 115.642 130.448C115.663 130.554 115.685 130.66 115.663 130.766L115.663 130.766C115.642 130.872 115.621 130.978 115.579 131.063C115.536 131.169 115.473 131.253 115.409 131.317C115.324 131.402 115.239 131.444 115.155 131.487C115.049 131.529 114.943 131.55 114.836 131.529C114.709 131.508 114.624 131.487 114.54 131.423C114.455 131.359 114.391 131.296 114.328 131.211C114.285 131.126 114.243 131.041 114.222 130.935ZM117.933 131.868L117.763 129.769L118.654 129.705C118.738 129.705 118.823 129.705 118.908 129.748C118.993 129.79 119.057 129.833 119.12 129.875C119.184 129.939 119.226 130.002 119.269 130.087C119.311 130.172 119.332 130.235 119.332 130.32C119.332 130.426 119.332 130.511 119.29 130.596C119.271 130.669 119.222 130.742 119.181 130.802L119.163 130.829C119.099 130.893 119.035 130.935 118.95 130.978L119.523 131.741L119.226 131.762L118.696 131.041L118.145 131.084L118.208 131.847L117.933 131.868ZM118.102 130.85L118.738 130.808C118.802 130.808 118.866 130.787 118.929 130.723C118.972 130.681 119.014 130.617 119.035 130.554C119.057 130.49 119.078 130.405 119.056 130.342C119.056 130.257 119.035 130.193 118.993 130.129C118.95 130.066 118.908 130.023 118.844 129.981C118.781 129.939 118.717 129.939 118.654 129.939L118.039 129.981L118.102 130.85ZM121.05 129.324L121.601 131.359L121.835 131.274L121.665 130.659L121.92 130.214L122.916 130.999L123.213 130.914L122.047 130.002L122.619 128.878L122.344 128.963L121.601 130.384L121.305 129.26L121.05 129.324ZM126.521 128.263C126.457 128.157 126.393 128.03 126.372 127.903C126.351 127.776 126.33 127.648 126.351 127.521C126.372 127.394 126.415 127.267 126.478 127.14C126.539 127.018 126.639 126.935 126.758 126.835L126.758 126.835L126.758 126.835L126.775 126.821C126.923 126.715 127.093 126.673 127.241 126.673C127.411 126.673 127.538 126.715 127.666 126.779L127.56 127.012C127.475 126.97 127.39 126.927 127.305 126.927C127.22 126.927 127.135 126.927 127.072 126.949C126.987 126.97 126.923 126.991 126.881 127.033C126.775 127.097 126.711 127.182 126.669 127.267C126.627 127.352 126.584 127.458 126.584 127.542C126.584 127.648 126.584 127.733 126.605 127.839C126.627 127.945 126.669 128.03 126.733 128.115C126.796 128.2 126.86 128.285 126.945 128.348C127.029 128.412 127.114 128.454 127.22 128.497L127.247 128.502C127.341 128.521 127.42 128.537 127.517 128.518C127.623 128.518 127.708 128.475 127.793 128.412C127.856 128.369 127.92 128.327 127.962 128.263C128.005 128.2 128.047 128.136 128.068 128.051C128.09 127.967 128.111 127.882 128.09 127.776L128.344 127.754C128.365 127.86 128.365 127.988 128.323 128.094C128.281 128.2 128.238 128.306 128.153 128.391C128.09 128.475 128.005 128.56 127.899 128.624C127.772 128.709 127.644 128.751 127.517 128.772C127.39 128.793 127.241 128.772 127.114 128.73C126.987 128.687 126.86 128.624 126.754 128.539C126.669 128.475 126.584 128.369 126.521 128.263ZM128.789 125.295L130.21 126.864L130.401 126.694L128.98 125.125L128.789 125.295ZM131.482 122.75L131.016 123.323L132.458 124.51L132.288 124.722L130.846 123.535L130.38 124.107L130.189 123.959L131.27 122.623L131.482 122.75ZM133.539 121.117L132.267 121.138L132.14 121.393L133.688 121.329L134.366 121.711L134.494 121.478L133.815 121.117L133.031 119.76L132.882 120.015L133.539 121.117ZM114.858 104.048L114.71 104.578H114.689C114.604 104.472 114.455 104.429 114.243 104.429H113.586V107.504C113.586 107.61 113.628 107.716 113.713 107.801V107.865H112.929V107.822C113.013 107.737 113.056 107.631 113.056 107.525V104.451H112.356C112.123 104.451 111.974 104.493 111.826 104.641L111.784 104.62L111.996 104.048H112.017C112.08 104.069 112.144 104.09 112.229 104.09H114.646C114.731 104.09 114.795 104.069 114.858 104.048ZM118.802 107.525V104.429C118.802 104.323 118.845 104.217 118.908 104.133V104.09H118.145C118.23 104.217 118.272 104.493 118.272 104.705V105.532H116.343V104.705C116.343 104.493 116.385 104.239 116.47 104.09H115.706V104.133C115.77 104.217 115.812 104.323 115.812 104.429V107.504C115.812 107.61 115.77 107.716 115.706 107.801V107.843H116.47C116.385 107.716 116.343 107.441 116.343 107.228V105.893H118.272V107.25C118.272 107.462 118.23 107.716 118.145 107.865H118.908V107.822C118.845 107.737 118.802 107.631 118.802 107.525ZM122.323 107.186L122.089 107.886C122.026 107.865 121.962 107.844 121.877 107.844H119.948V107.801C120.011 107.716 120.054 107.61 120.054 107.504V104.43C120.054 104.324 120.011 104.218 119.948 104.133V104.09H121.729C121.835 104.09 121.941 104.09 122.026 104.048H122.047V104.748H122.026C121.92 104.514 121.814 104.43 121.496 104.43H120.584V105.532H121.474C121.559 105.532 121.623 105.511 121.665 105.469H121.686V105.978H121.665C121.559 105.914 121.453 105.872 121.347 105.872H120.584V107.504H121.58C121.962 107.504 122.153 107.335 122.301 107.165L122.323 107.186ZM114.032 113.929V113.887C113.968 113.802 113.862 113.59 113.841 113.208L113.65 110.494C113.629 110.388 113.693 110.282 113.777 110.197V110.155H112.972L111.784 112.89L110.639 110.155H109.791V110.197C109.876 110.282 109.939 110.388 109.918 110.494L109.727 113.208C109.706 113.569 109.6 113.781 109.536 113.866V113.908H110.194C110.109 113.781 110.088 113.505 110.109 113.293L110.3 110.706L111.657 113.929H111.742L113.12 110.706L113.29 113.314C113.311 113.526 113.29 113.781 113.205 113.929H114.032ZM118.527 113.887V113.929H117.637C117.658 113.696 117.594 113.463 117.509 113.251L117.17 112.424H115.877L115.537 113.251C115.431 113.484 115.389 113.717 115.41 113.929H114.71V113.887L114.719 113.879C114.864 113.755 114.988 113.649 115.113 113.399L116.279 110.643C116.343 110.494 116.343 110.325 116.258 110.219V110.176H116.788L118.145 113.399C118.25 113.649 118.374 113.756 118.519 113.88L118.527 113.887ZM117.022 112.106L116.513 110.897L116.004 112.106H117.022ZM120.075 110.155H119.312V110.197C119.375 110.282 119.418 110.388 119.418 110.494V113.59C119.418 113.696 119.375 113.802 119.312 113.887V113.929H120.075V113.887C120.012 113.802 119.969 113.696 119.969 113.59V110.494C119.969 110.388 120.012 110.282 120.075 110.197V110.155ZM124.57 110.155V110.197C124.507 110.282 124.464 110.388 124.464 110.494V113.929H124.38L121.665 110.94V113.293C121.665 113.505 121.708 113.781 121.793 113.908H121.178V113.866C121.241 113.781 121.284 113.675 121.284 113.569V110.643C121.284 110.452 121.178 110.282 121.072 110.197V110.155H121.687L124.104 112.827V110.77C124.104 110.558 124.061 110.282 123.977 110.155H124.57ZM114.858 116.728L115.007 116.198L114.985 116.177L114.985 116.177C114.922 116.198 114.858 116.219 114.773 116.219H112.377C112.292 116.219 112.229 116.198 112.165 116.177H112.144L111.932 116.749L111.974 116.771C112.123 116.622 112.271 116.58 112.504 116.58H113.204V119.654C113.204 119.76 113.162 119.866 113.077 119.951V119.994H113.862V119.951C113.777 119.866 113.734 119.76 113.734 119.654V116.58H114.392C114.604 116.58 114.752 116.622 114.837 116.728H114.858ZM118.866 119.951V119.994H117.975C117.997 119.76 117.933 119.527 117.848 119.315L117.509 118.488H116.215L115.876 119.315C115.77 119.548 115.728 119.782 115.749 119.994H115.049V119.951L115.058 119.944L115.058 119.944C115.203 119.82 115.327 119.713 115.452 119.464L116.618 116.707C116.682 116.559 116.682 116.389 116.597 116.283V116.24H117.127L118.484 119.464C118.588 119.714 118.713 119.82 118.858 119.945L118.866 119.951ZM117.36 118.17L116.852 116.961L116.343 118.17H117.36ZM120.669 120.057C121.729 120.057 122.174 119.464 122.174 118.87C122.174 118.213 121.602 117.894 121.305 117.831C121.623 117.682 121.792 117.386 121.792 117.046C121.792 116.559 121.432 116.156 120.52 116.156C120.285 116.156 120.003 116.179 119.752 116.2C119.664 116.207 119.58 116.214 119.502 116.219V116.262C119.566 116.347 119.608 116.453 119.608 116.559V119.654C119.608 119.761 119.566 119.867 119.502 119.951V119.994C119.556 119.997 119.616 120.002 119.681 120.006C119.999 120.028 120.422 120.057 120.669 120.057ZM120.138 116.516C120.244 116.495 120.35 116.495 120.435 116.495C121.05 116.495 121.283 116.728 121.283 117.152C121.283 117.47 121.177 117.788 120.266 117.788H120.138V116.516ZM120.541 118.085C121.305 118.085 121.623 118.382 121.623 118.912C121.623 119.294 121.453 119.697 120.626 119.718C120.499 119.718 120.308 119.697 120.138 119.676V118.107C120.175 118.107 120.227 118.103 120.287 118.098C120.365 118.092 120.457 118.085 120.541 118.085Z",
      morphConfigEllipse_201d: "M142 150 A21.5 5 0 0 1 120.5 155 A21.5 5 0 0 1 99 150 A21.5 5 0 0 1 142 150z",
    },
  });
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    state: "up" | "down";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      state: "up",
    },
    1: {
      state: "down",
    },
  };

  function getNextMorphState(): number {
    const { state, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].state === state) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Matrix",
        morphId: "morphConfigBackgroundd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [0.9999999999999998, 0, -2.220446049250313e-16, 1, -5.684341886080802e-14, 3],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigLogoTextd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1, 0, 0, 1.0000000000000004, 0, 2.9999999999998863],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigEllipse_201d",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            1.069767441860464,
            -8.881784197001252e-16,
            1.7763568394002505e-15,
            1.1999999999999957,
            -7.906976744185158,
            -28.99999999999818,
          ],
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);




  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} style={svgStyle}>
          <G id="state_3Dup">
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 234 329">
              <G id="Logo">
                <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 234 329">
                  <Path
                    id="Background"
                    fill="#2C4B46"
                    d="M142 112 A25 25 0 0 1 117 137 A25 25 0 0 1 92 112 A25 25 0 0 1 142 112z"
                    ref={morphProps.bindInterpolation}
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Svg preserveAspectRatio="none" viewBox="0 0 234 329">
                  <Path
                    id="LogoText"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M95.733 112.063C95.733 100.283 105.283 90.7327 117.064 90.7327C128.844 90.7327 138.394 100.283 138.394 112.063C138.394 123.844 128.844 133.394 117.064 133.394C105.283 133.394 95.733 123.844 95.733 112.063ZM117.064 89.7966C104.766 89.7966 94.7969 99.7657 94.7969 112.063C94.7969 124.361 104.766 134.33 117.064 134.33C129.361 134.33 139.33 124.361 139.33 112.063C139.33 99.7657 129.361 89.7966 117.064 89.7966ZM101.813 112.063C101.813 103.64 108.641 96.8124 117.063 96.8124C125.486 96.8124 132.314 103.64 132.314 112.063C132.314 120.486 125.486 127.314 117.063 127.314C108.641 127.314 101.813 120.486 101.813 112.063ZM117.063 96.1428C108.271 96.1428 101.143 103.271 101.143 112.063C101.143 120.856 108.271 127.983 117.063 127.983C125.856 127.983 132.984 120.856 132.984 112.063C132.984 103.271 125.856 96.1428 117.063 96.1428ZM102.623 98.7889L102.793 98.5981L103.514 98.9162L103.174 98.1952L103.344 98.0044L103.747 98.895L104.616 99.2342L103.832 97.4742L104.044 97.2622L104.934 99.3615L104.807 99.5523L103.789 99.1706L104.213 100.167L104.044 100.337L101.923 99.5099L102.114 99.2978L103.895 100.04L103.535 99.1706L102.623 98.7889ZM108.37 96.8594L107.224 95.0782L106.991 95.2266L107.479 95.99L106.504 96.6049L106.016 95.8415L105.783 95.99L106.928 97.75L107.161 97.6227L106.652 96.817L107.627 96.202L108.136 97.0078L108.37 96.8594ZM110.872 95.693C110.723 95.7355 110.596 95.7567 110.469 95.7567C110.342 95.7355 110.214 95.7142 110.087 95.6506C109.96 95.587 109.875 95.5022 109.769 95.3962C109.684 95.2902 109.621 95.1841 109.557 95.0569C109.515 94.9297 109.493 94.7812 109.493 94.654C109.493 94.5268 109.515 94.3783 109.578 94.2511C109.621 94.1239 109.706 94.0179 109.79 93.9118C109.875 93.8058 110.002 93.7422 110.13 93.6998C110.278 93.6574 110.405 93.6362 110.533 93.6362C110.66 93.6574 110.787 93.6998 110.914 93.7634C111.041 93.827 111.126 93.9118 111.232 94.0179C111.317 94.1239 111.381 94.2299 111.444 94.3571C111.487 94.4844 111.508 94.6328 111.508 94.76C111.508 94.8873 111.487 95.0357 111.423 95.1629C111.381 95.2902 111.296 95.3962 111.211 95.5022C111.126 95.6082 110.999 95.6506 110.872 95.693ZM109.812 94.9509C109.854 95.0569 109.896 95.1417 109.96 95.2265C110.024 95.3114 110.108 95.375 110.193 95.4174C110.278 95.4598 110.363 95.5022 110.469 95.5022C110.575 95.5234 110.66 95.5022 110.766 95.4598C110.872 95.4174 110.957 95.3538 111.02 95.2902C111.084 95.2053 111.126 95.1205 111.169 95.0357C111.211 94.9509 111.211 94.8449 111.211 94.7388C111.211 94.6328 111.19 94.5268 111.147 94.442C111.105 94.3359 111.063 94.2511 110.999 94.1663C110.935 94.0815 110.851 94.0179 110.766 93.9755C110.681 93.933 110.575 93.8906 110.49 93.8906C110.384 93.8906 110.299 93.8906 110.193 93.933C110.087 93.9755 110.002 94.0391 109.939 94.1027C109.875 94.1875 109.833 94.2723 109.79 94.3571L109.79 94.3571L109.781 94.4023C109.763 94.4884 109.748 94.5634 109.748 94.654L109.748 94.6541C109.769 94.7601 109.79 94.8661 109.812 94.9509ZM113.204 92.8302L113.544 94.9083L114.986 94.675L114.943 94.4418L113.777 94.6326L113.459 92.7878L113.204 92.8302ZM118.103 94.336V94.5692L116.682 94.548L116.724 92.4488L118.124 92.47V92.7032L116.979 92.682V93.3606L117.975 93.3818V93.5938L116.979 93.5726L116.958 94.2936L118.103 94.336ZM121.219 93.212C121.304 93.2756 121.368 93.3392 121.41 93.4028L121.601 93.2544C121.516 93.1696 121.431 93.0847 121.325 93.0211C121.219 92.9575 121.092 92.8939 120.965 92.8727C120.816 92.8515 120.689 92.8515 120.562 92.8727C120.456 92.8939 120.35 92.9363 120.265 93.0211C120.18 93.1059 120.117 93.212 120.095 93.3392C120.074 93.4452 120.074 93.53 120.117 93.6149C120.159 93.6997 120.223 93.7633 120.307 93.8269L120.308 93.8269C120.414 93.8905 120.52 93.9541 120.647 94.0178C120.719 94.0467 120.792 94.0856 120.857 94.1209L120.857 94.1209C120.888 94.1372 120.917 94.1528 120.944 94.1662C121.007 94.2086 121.071 94.251 121.113 94.3146C121.134 94.357 121.156 94.4206 121.134 94.5055C121.113 94.6115 121.05 94.6751 120.965 94.7175C120.88 94.7599 120.753 94.7599 120.604 94.7387C120.498 94.7175 120.392 94.6751 120.307 94.6327C120.223 94.5903 120.138 94.5479 120.074 94.4843C120.039 94.4492 120.011 94.4142 119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827C119.964 94.357 119.945 94.3337 119.926 94.3146L119.756 94.5055C119.968 94.7599 120.223 94.9084 120.541 94.972C120.689 95.0144 120.816 95.0144 120.944 94.9932C121.05 94.9932 121.156 94.9296 121.241 94.8659C121.325 94.8023 121.389 94.6963 121.41 94.5691C121.431 94.4418 121.431 94.3358 121.389 94.251C121.347 94.1662 121.283 94.0814 121.177 94.0178C121.092 93.9541 120.965 93.8905 120.838 93.8269L120.541 93.6785C120.477 93.6361 120.414 93.5724 120.392 93.53C120.371 93.4664 120.35 93.4028 120.371 93.3392C120.392 93.2332 120.456 93.1484 120.541 93.1059C120.626 93.0635 120.732 93.0423 120.901 93.0847C121.028 93.1059 121.134 93.1484 121.219 93.212ZM124.337 93.8693L124.549 93.9541V96.2231L124.294 96.117V95.4597L123.467 95.1204L123.001 95.6081L122.746 95.5021L124.337 93.8693ZM124.316 95.2264L124.337 94.1874L123.616 94.9508L124.316 95.2264ZM127.2 95.2903L126.055 97.0503L127.264 97.8349L127.391 97.644L126.415 97.0079L127.433 95.4387L127.2 95.2903ZM129.786 99.7219L129.616 99.8915L128.577 98.8949L130.041 97.3682L131.058 98.3436L130.889 98.5132L130.062 97.7287L129.595 98.2164L130.316 98.8949L130.168 99.0646L129.447 98.386L128.938 98.9161L129.786 99.7219ZM99.6969 121.626L101.075 120.799L100.333 122.729L100.46 122.941L102.263 121.859L102.135 121.605L100.715 122.453L101.478 120.502L101.372 120.312L99.5696 121.393L99.6969 121.626ZM102.941 125.655L102.771 125.804L101.817 124.743L103.386 123.344L104.319 124.383L104.149 124.531L103.386 123.683L102.877 124.128L103.534 124.871L103.365 125.019L102.707 124.277L102.156 124.765L102.941 125.655ZM106.397 126.207L106.185 126.058L105.952 127.012L105.146 127.5L105.634 125.634L105.401 125.464L104.87 127.691L105.061 127.818L105.994 127.267L105.74 128.327L105.931 128.454L107.882 127.267L107.648 127.097L106.015 128.136L106.228 127.224L107.055 126.694L106.842 126.546L106.185 126.97L106.397 126.207ZM111.19 128.793L111.465 130.023L112.398 129.154L112.674 129.239L111.508 130.278L111.275 131.02L111.02 130.935L111.253 130.193L110.893 128.687L111.19 128.793ZM114.412 131.635C114.518 131.699 114.646 131.741 114.794 131.762C114.943 131.783 115.07 131.762 115.197 131.72C115.324 131.677 115.43 131.614 115.536 131.529C115.642 131.444 115.727 131.338 115.791 131.211C115.854 131.105 115.897 130.978 115.918 130.829C115.939 130.681 115.939 130.554 115.897 130.426C115.854 130.299 115.812 130.172 115.727 130.066C115.663 129.96 115.557 129.875 115.451 129.79C115.345 129.727 115.218 129.684 115.07 129.663C114.921 129.642 114.794 129.663 114.667 129.705C114.54 129.748 114.434 129.811 114.328 129.896C114.222 129.981 114.137 130.087 114.073 130.214C114.009 130.32 113.967 130.448 113.946 130.596C113.925 130.723 113.925 130.872 113.967 130.999C114.009 131.126 114.052 131.253 114.137 131.359C114.2 131.465 114.306 131.571 114.412 131.635ZM114.222 130.935C114.2 130.829 114.179 130.723 114.2 130.617C114.222 130.511 114.243 130.426 114.285 130.32C114.328 130.214 114.391 130.129 114.455 130.066C114.54 129.981 114.624 129.939 114.709 129.896C114.815 129.854 114.921 129.833 115.027 129.854C115.133 129.875 115.218 129.896 115.303 129.96C115.388 130.023 115.451 130.087 115.515 130.172C115.579 130.257 115.621 130.342 115.642 130.448C115.663 130.554 115.685 130.66 115.663 130.766L115.663 130.766C115.642 130.872 115.621 130.978 115.579 131.063C115.536 131.169 115.473 131.253 115.409 131.317C115.324 131.402 115.239 131.444 115.155 131.487C115.049 131.529 114.943 131.55 114.836 131.529C114.709 131.508 114.624 131.487 114.54 131.423C114.455 131.359 114.391 131.296 114.328 131.211C114.285 131.126 114.243 131.041 114.222 130.935ZM117.933 131.868L117.763 129.769L118.654 129.705C118.738 129.705 118.823 129.705 118.908 129.748C118.993 129.79 119.057 129.833 119.12 129.875C119.184 129.939 119.226 130.002 119.269 130.087C119.311 130.172 119.332 130.235 119.332 130.32C119.332 130.426 119.332 130.511 119.29 130.596C119.271 130.669 119.222 130.742 119.181 130.802L119.163 130.829C119.099 130.893 119.035 130.935 118.95 130.978L119.523 131.741L119.226 131.762L118.696 131.041L118.145 131.084L118.208 131.847L117.933 131.868ZM118.102 130.85L118.738 130.808C118.802 130.808 118.866 130.787 118.929 130.723C118.972 130.681 119.014 130.617 119.035 130.554C119.057 130.49 119.078 130.405 119.056 130.342C119.056 130.257 119.035 130.193 118.993 130.129C118.95 130.066 118.908 130.023 118.844 129.981C118.781 129.939 118.717 129.939 118.654 129.939L118.039 129.981L118.102 130.85ZM121.05 129.324L121.601 131.359L121.835 131.274L121.665 130.659L121.92 130.214L122.916 130.999L123.213 130.914L122.047 130.002L122.619 128.878L122.344 128.963L121.601 130.384L121.305 129.26L121.05 129.324ZM126.521 128.263C126.457 128.157 126.393 128.03 126.372 127.903C126.351 127.776 126.33 127.648 126.351 127.521C126.372 127.394 126.415 127.267 126.478 127.14C126.539 127.018 126.639 126.935 126.758 126.835L126.758 126.835L126.758 126.835L126.775 126.821C126.923 126.715 127.093 126.673 127.241 126.673C127.411 126.673 127.538 126.715 127.666 126.779L127.56 127.012C127.475 126.97 127.39 126.927 127.305 126.927C127.22 126.927 127.135 126.927 127.072 126.949C126.987 126.97 126.923 126.991 126.881 127.033C126.775 127.097 126.711 127.182 126.669 127.267C126.627 127.352 126.584 127.458 126.584 127.542C126.584 127.648 126.584 127.733 126.605 127.839C126.627 127.945 126.669 128.03 126.733 128.115C126.796 128.2 126.86 128.285 126.945 128.348C127.029 128.412 127.114 128.454 127.22 128.497L127.247 128.502C127.341 128.521 127.42 128.537 127.517 128.518C127.623 128.518 127.708 128.475 127.793 128.412C127.856 128.369 127.92 128.327 127.962 128.263C128.005 128.2 128.047 128.136 128.068 128.051C128.09 127.967 128.111 127.882 128.09 127.776L128.344 127.754C128.365 127.86 128.365 127.988 128.323 128.094C128.281 128.2 128.238 128.306 128.153 128.391C128.09 128.475 128.005 128.56 127.899 128.624C127.772 128.709 127.644 128.751 127.517 128.772C127.39 128.793 127.241 128.772 127.114 128.73C126.987 128.687 126.86 128.624 126.754 128.539C126.669 128.475 126.584 128.369 126.521 128.263ZM128.789 125.295L130.21 126.864L130.401 126.694L128.98 125.125L128.789 125.295ZM131.482 122.75L131.016 123.323L132.458 124.51L132.288 124.722L130.846 123.535L130.38 124.107L130.189 123.959L131.27 122.623L131.482 122.75ZM133.539 121.117L132.267 121.138L132.14 121.393L133.688 121.329L134.366 121.711L134.494 121.478L133.815 121.117L133.031 119.76L132.882 120.015L133.539 121.117ZM114.858 104.048L114.71 104.578H114.689C114.604 104.472 114.455 104.429 114.243 104.429H113.586V107.504C113.586 107.61 113.628 107.716 113.713 107.801V107.865H112.929V107.822C113.013 107.737 113.056 107.631 113.056 107.525V104.451H112.356C112.123 104.451 111.974 104.493 111.826 104.641L111.784 104.62L111.996 104.048H112.017C112.08 104.069 112.144 104.09 112.229 104.09H114.646C114.731 104.09 114.795 104.069 114.858 104.048ZM118.802 107.525V104.429C118.802 104.323 118.845 104.217 118.908 104.133V104.09H118.145C118.23 104.217 118.272 104.493 118.272 104.705V105.532H116.343V104.705C116.343 104.493 116.385 104.239 116.47 104.09H115.706V104.133C115.77 104.217 115.812 104.323 115.812 104.429V107.504C115.812 107.61 115.77 107.716 115.706 107.801V107.843H116.47C116.385 107.716 116.343 107.441 116.343 107.228V105.893H118.272V107.25C118.272 107.462 118.23 107.716 118.145 107.865H118.908V107.822C118.845 107.737 118.802 107.631 118.802 107.525ZM122.323 107.186L122.089 107.886C122.026 107.865 121.962 107.844 121.877 107.844H119.948V107.801C120.011 107.716 120.054 107.61 120.054 107.504V104.43C120.054 104.324 120.011 104.218 119.948 104.133V104.09H121.729C121.835 104.09 121.941 104.09 122.026 104.048H122.047V104.748H122.026C121.92 104.514 121.814 104.43 121.496 104.43H120.584V105.532H121.474C121.559 105.532 121.623 105.511 121.665 105.469H121.686V105.978H121.665C121.559 105.914 121.453 105.872 121.347 105.872H120.584V107.504H121.58C121.962 107.504 122.153 107.335 122.301 107.165L122.323 107.186ZM114.032 113.929V113.887C113.968 113.802 113.862 113.59 113.841 113.208L113.65 110.494C113.629 110.388 113.693 110.282 113.777 110.197V110.155H112.972L111.784 112.89L110.639 110.155H109.791V110.197C109.876 110.282 109.939 110.388 109.918 110.494L109.727 113.208C109.706 113.569 109.6 113.781 109.536 113.866V113.908H110.194C110.109 113.781 110.088 113.505 110.109 113.293L110.3 110.706L111.657 113.929H111.742L113.12 110.706L113.29 113.314C113.311 113.526 113.29 113.781 113.205 113.929H114.032ZM118.527 113.887V113.929H117.637C117.658 113.696 117.594 113.463 117.509 113.251L117.17 112.424H115.877L115.537 113.251C115.431 113.484 115.389 113.717 115.41 113.929H114.71V113.887L114.719 113.879C114.864 113.755 114.988 113.649 115.113 113.399L116.279 110.643C116.343 110.494 116.343 110.325 116.258 110.219V110.176H116.788L118.145 113.399C118.25 113.649 118.374 113.756 118.519 113.88L118.527 113.887ZM117.022 112.106L116.513 110.897L116.004 112.106H117.022ZM120.075 110.155H119.312V110.197C119.375 110.282 119.418 110.388 119.418 110.494V113.59C119.418 113.696 119.375 113.802 119.312 113.887V113.929H120.075V113.887C120.012 113.802 119.969 113.696 119.969 113.59V110.494C119.969 110.388 120.012 110.282 120.075 110.197V110.155ZM124.57 110.155V110.197C124.507 110.282 124.464 110.388 124.464 110.494V113.929H124.38L121.665 110.94V113.293C121.665 113.505 121.708 113.781 121.793 113.908H121.178V113.866C121.241 113.781 121.284 113.675 121.284 113.569V110.643C121.284 110.452 121.178 110.282 121.072 110.197V110.155H121.687L124.104 112.827V110.77C124.104 110.558 124.061 110.282 123.977 110.155H124.57ZM114.858 116.728L115.007 116.198L114.985 116.177L114.985 116.177C114.922 116.198 114.858 116.219 114.773 116.219H112.377C112.292 116.219 112.229 116.198 112.165 116.177H112.144L111.932 116.749L111.974 116.771C112.123 116.622 112.271 116.58 112.504 116.58H113.204V119.654C113.204 119.76 113.162 119.866 113.077 119.951V119.994H113.862V119.951C113.777 119.866 113.734 119.76 113.734 119.654V116.58H114.392C114.604 116.58 114.752 116.622 114.837 116.728H114.858ZM118.866 119.951V119.994H117.975C117.997 119.76 117.933 119.527 117.848 119.315L117.509 118.488H116.215L115.876 119.315C115.77 119.548 115.728 119.782 115.749 119.994H115.049V119.951L115.058 119.944L115.058 119.944C115.203 119.82 115.327 119.713 115.452 119.464L116.618 116.707C116.682 116.559 116.682 116.389 116.597 116.283V116.24H117.127L118.484 119.464C118.588 119.714 118.713 119.82 118.858 119.945L118.866 119.951ZM117.36 118.17L116.852 116.961L116.343 118.17H117.36ZM120.669 120.057C121.729 120.057 122.174 119.464 122.174 118.87C122.174 118.213 121.602 117.894 121.305 117.831C121.623 117.682 121.792 117.386 121.792 117.046C121.792 116.559 121.432 116.156 120.52 116.156C120.285 116.156 120.003 116.179 119.752 116.2C119.664 116.207 119.58 116.214 119.502 116.219V116.262C119.566 116.347 119.608 116.453 119.608 116.559V119.654C119.608 119.761 119.566 119.867 119.502 119.951V119.994C119.556 119.997 119.616 120.002 119.681 120.006C119.999 120.028 120.422 120.057 120.669 120.057ZM120.138 116.516C120.244 116.495 120.35 116.495 120.435 116.495C121.05 116.495 121.283 116.728 121.283 117.152C121.283 117.47 121.177 117.788 120.266 117.788H120.138V116.516ZM120.541 118.085C121.305 118.085 121.623 118.382 121.623 118.912C121.623 119.294 121.453 119.697 120.626 119.718C120.499 119.718 120.308 119.697 120.138 119.676V118.107C120.175 118.107 120.227 118.103 120.287 118.098C120.365 118.092 120.457 118.085 120.541 118.085Z"
                    fill="white"
                    ref={morphProps.bindInterpolation}
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
              </G>
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 234 329">
              <Path
                id="Ellipse_201"
                fill="#E6E6E6"
                d="M142 150 A21.5 5 0 0 1 120.5 155 A21.5 5 0 0 1 99 150 A21.5 5 0 0 1 142 150z"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 234 329"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Logo">
          <Path
            id="Background"
            fill="#2C4B46"
            d="M142 112 A25 25 0 0 1 117 137 A25 25 0 0 1 92 112 A25 25 0 0 1 142 112z"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            id="LogoText"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M95.733 112.063C95.733 100.283 105.283 90.7327 117.064 90.7327C128.844 90.7327 138.394 100.283 138.394 112.063C138.394 123.844 128.844 133.394 117.064 133.394C105.283 133.394 95.733 123.844 95.733 112.063ZM117.064 89.7966C104.766 89.7966 94.7969 99.7657 94.7969 112.063C94.7969 124.361 104.766 134.33 117.064 134.33C129.361 134.33 139.33 124.361 139.33 112.063C139.33 99.7657 129.361 89.7966 117.064 89.7966ZM101.813 112.063C101.813 103.64 108.641 96.8124 117.063 96.8124C125.486 96.8124 132.314 103.64 132.314 112.063C132.314 120.486 125.486 127.314 117.063 127.314C108.641 127.314 101.813 120.486 101.813 112.063ZM117.063 96.1428C108.271 96.1428 101.143 103.271 101.143 112.063C101.143 120.856 108.271 127.983 117.063 127.983C125.856 127.983 132.984 120.856 132.984 112.063C132.984 103.271 125.856 96.1428 117.063 96.1428ZM102.623 98.7889L102.793 98.5981L103.514 98.9162L103.174 98.1952L103.344 98.0044L103.747 98.895L104.616 99.2342L103.832 97.4742L104.044 97.2622L104.934 99.3615L104.807 99.5523L103.789 99.1706L104.213 100.167L104.044 100.337L101.923 99.5099L102.114 99.2978L103.895 100.04L103.535 99.1706L102.623 98.7889ZM108.37 96.8594L107.224 95.0782L106.991 95.2266L107.479 95.99L106.504 96.6049L106.016 95.8415L105.783 95.99L106.928 97.75L107.161 97.6227L106.652 96.817L107.627 96.202L108.136 97.0078L108.37 96.8594ZM110.872 95.693C110.723 95.7355 110.596 95.7567 110.469 95.7567C110.342 95.7355 110.214 95.7142 110.087 95.6506C109.96 95.587 109.875 95.5022 109.769 95.3962C109.684 95.2902 109.621 95.1841 109.557 95.0569C109.515 94.9297 109.493 94.7812 109.493 94.654C109.493 94.5268 109.515 94.3783 109.578 94.2511C109.621 94.1239 109.706 94.0179 109.79 93.9118C109.875 93.8058 110.002 93.7422 110.13 93.6998C110.278 93.6574 110.405 93.6362 110.533 93.6362C110.66 93.6574 110.787 93.6998 110.914 93.7634C111.041 93.827 111.126 93.9118 111.232 94.0179C111.317 94.1239 111.381 94.2299 111.444 94.3571C111.487 94.4844 111.508 94.6328 111.508 94.76C111.508 94.8873 111.487 95.0357 111.423 95.1629C111.381 95.2902 111.296 95.3962 111.211 95.5022C111.126 95.6082 110.999 95.6506 110.872 95.693ZM109.812 94.9509C109.854 95.0569 109.896 95.1417 109.96 95.2265C110.024 95.3114 110.108 95.375 110.193 95.4174C110.278 95.4598 110.363 95.5022 110.469 95.5022C110.575 95.5234 110.66 95.5022 110.766 95.4598C110.872 95.4174 110.957 95.3538 111.02 95.2902C111.084 95.2053 111.126 95.1205 111.169 95.0357C111.211 94.9509 111.211 94.8449 111.211 94.7388C111.211 94.6328 111.19 94.5268 111.147 94.442C111.105 94.3359 111.063 94.2511 110.999 94.1663C110.935 94.0815 110.851 94.0179 110.766 93.9755C110.681 93.933 110.575 93.8906 110.49 93.8906C110.384 93.8906 110.299 93.8906 110.193 93.933C110.087 93.9755 110.002 94.0391 109.939 94.1027C109.875 94.1875 109.833 94.2723 109.79 94.3571L109.79 94.3571L109.781 94.4023C109.763 94.4884 109.748 94.5634 109.748 94.654L109.748 94.6541C109.769 94.7601 109.79 94.8661 109.812 94.9509ZM113.204 92.8302L113.544 94.9083L114.986 94.675L114.943 94.4418L113.777 94.6326L113.459 92.7878L113.204 92.8302ZM118.103 94.336V94.5692L116.682 94.548L116.724 92.4488L118.124 92.47V92.7032L116.979 92.682V93.3606L117.975 93.3818V93.5938L116.979 93.5726L116.958 94.2936L118.103 94.336ZM121.219 93.212C121.304 93.2756 121.368 93.3392 121.41 93.4028L121.601 93.2544C121.516 93.1696 121.431 93.0847 121.325 93.0211C121.219 92.9575 121.092 92.8939 120.965 92.8727C120.816 92.8515 120.689 92.8515 120.562 92.8727C120.456 92.8939 120.35 92.9363 120.265 93.0211C120.18 93.1059 120.117 93.212 120.095 93.3392C120.074 93.4452 120.074 93.53 120.117 93.6149C120.159 93.6997 120.223 93.7633 120.307 93.8269L120.308 93.8269C120.414 93.8905 120.52 93.9541 120.647 94.0178C120.719 94.0467 120.792 94.0856 120.857 94.1209L120.857 94.1209C120.888 94.1372 120.917 94.1528 120.944 94.1662C121.007 94.2086 121.071 94.251 121.113 94.3146C121.134 94.357 121.156 94.4206 121.134 94.5055C121.113 94.6115 121.05 94.6751 120.965 94.7175C120.88 94.7599 120.753 94.7599 120.604 94.7387C120.498 94.7175 120.392 94.6751 120.307 94.6327C120.223 94.5903 120.138 94.5479 120.074 94.4843C120.039 94.4492 120.011 94.4142 119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827L119.985 94.3827C119.964 94.357 119.945 94.3337 119.926 94.3146L119.756 94.5055C119.968 94.7599 120.223 94.9084 120.541 94.972C120.689 95.0144 120.816 95.0144 120.944 94.9932C121.05 94.9932 121.156 94.9296 121.241 94.8659C121.325 94.8023 121.389 94.6963 121.41 94.5691C121.431 94.4418 121.431 94.3358 121.389 94.251C121.347 94.1662 121.283 94.0814 121.177 94.0178C121.092 93.9541 120.965 93.8905 120.838 93.8269L120.541 93.6785C120.477 93.6361 120.414 93.5724 120.392 93.53C120.371 93.4664 120.35 93.4028 120.371 93.3392C120.392 93.2332 120.456 93.1484 120.541 93.1059C120.626 93.0635 120.732 93.0423 120.901 93.0847C121.028 93.1059 121.134 93.1484 121.219 93.212ZM124.337 93.8693L124.549 93.9541V96.2231L124.294 96.117V95.4597L123.467 95.1204L123.001 95.6081L122.746 95.5021L124.337 93.8693ZM124.316 95.2264L124.337 94.1874L123.616 94.9508L124.316 95.2264ZM127.2 95.2903L126.055 97.0503L127.264 97.8349L127.391 97.644L126.415 97.0079L127.433 95.4387L127.2 95.2903ZM129.786 99.7219L129.616 99.8915L128.577 98.8949L130.041 97.3682L131.058 98.3436L130.889 98.5132L130.062 97.7287L129.595 98.2164L130.316 98.8949L130.168 99.0646L129.447 98.386L128.938 98.9161L129.786 99.7219ZM99.6969 121.626L101.075 120.799L100.333 122.729L100.46 122.941L102.263 121.859L102.135 121.605L100.715 122.453L101.478 120.502L101.372 120.312L99.5696 121.393L99.6969 121.626ZM102.941 125.655L102.771 125.804L101.817 124.743L103.386 123.344L104.319 124.383L104.149 124.531L103.386 123.683L102.877 124.128L103.534 124.871L103.365 125.019L102.707 124.277L102.156 124.765L102.941 125.655ZM106.397 126.207L106.185 126.058L105.952 127.012L105.146 127.5L105.634 125.634L105.401 125.464L104.87 127.691L105.061 127.818L105.994 127.267L105.74 128.327L105.931 128.454L107.882 127.267L107.648 127.097L106.015 128.136L106.228 127.224L107.055 126.694L106.842 126.546L106.185 126.97L106.397 126.207ZM111.19 128.793L111.465 130.023L112.398 129.154L112.674 129.239L111.508 130.278L111.275 131.02L111.02 130.935L111.253 130.193L110.893 128.687L111.19 128.793ZM114.412 131.635C114.518 131.699 114.646 131.741 114.794 131.762C114.943 131.783 115.07 131.762 115.197 131.72C115.324 131.677 115.43 131.614 115.536 131.529C115.642 131.444 115.727 131.338 115.791 131.211C115.854 131.105 115.897 130.978 115.918 130.829C115.939 130.681 115.939 130.554 115.897 130.426C115.854 130.299 115.812 130.172 115.727 130.066C115.663 129.96 115.557 129.875 115.451 129.79C115.345 129.727 115.218 129.684 115.07 129.663C114.921 129.642 114.794 129.663 114.667 129.705C114.54 129.748 114.434 129.811 114.328 129.896C114.222 129.981 114.137 130.087 114.073 130.214C114.009 130.32 113.967 130.448 113.946 130.596C113.925 130.723 113.925 130.872 113.967 130.999C114.009 131.126 114.052 131.253 114.137 131.359C114.2 131.465 114.306 131.571 114.412 131.635ZM114.222 130.935C114.2 130.829 114.179 130.723 114.2 130.617C114.222 130.511 114.243 130.426 114.285 130.32C114.328 130.214 114.391 130.129 114.455 130.066C114.54 129.981 114.624 129.939 114.709 129.896C114.815 129.854 114.921 129.833 115.027 129.854C115.133 129.875 115.218 129.896 115.303 129.96C115.388 130.023 115.451 130.087 115.515 130.172C115.579 130.257 115.621 130.342 115.642 130.448C115.663 130.554 115.685 130.66 115.663 130.766L115.663 130.766C115.642 130.872 115.621 130.978 115.579 131.063C115.536 131.169 115.473 131.253 115.409 131.317C115.324 131.402 115.239 131.444 115.155 131.487C115.049 131.529 114.943 131.55 114.836 131.529C114.709 131.508 114.624 131.487 114.54 131.423C114.455 131.359 114.391 131.296 114.328 131.211C114.285 131.126 114.243 131.041 114.222 130.935ZM117.933 131.868L117.763 129.769L118.654 129.705C118.738 129.705 118.823 129.705 118.908 129.748C118.993 129.79 119.057 129.833 119.12 129.875C119.184 129.939 119.226 130.002 119.269 130.087C119.311 130.172 119.332 130.235 119.332 130.32C119.332 130.426 119.332 130.511 119.29 130.596C119.271 130.669 119.222 130.742 119.181 130.802L119.163 130.829C119.099 130.893 119.035 130.935 118.95 130.978L119.523 131.741L119.226 131.762L118.696 131.041L118.145 131.084L118.208 131.847L117.933 131.868ZM118.102 130.85L118.738 130.808C118.802 130.808 118.866 130.787 118.929 130.723C118.972 130.681 119.014 130.617 119.035 130.554C119.057 130.49 119.078 130.405 119.056 130.342C119.056 130.257 119.035 130.193 118.993 130.129C118.95 130.066 118.908 130.023 118.844 129.981C118.781 129.939 118.717 129.939 118.654 129.939L118.039 129.981L118.102 130.85ZM121.05 129.324L121.601 131.359L121.835 131.274L121.665 130.659L121.92 130.214L122.916 130.999L123.213 130.914L122.047 130.002L122.619 128.878L122.344 128.963L121.601 130.384L121.305 129.26L121.05 129.324ZM126.521 128.263C126.457 128.157 126.393 128.03 126.372 127.903C126.351 127.776 126.33 127.648 126.351 127.521C126.372 127.394 126.415 127.267 126.478 127.14C126.539 127.018 126.639 126.935 126.758 126.835L126.758 126.835L126.758 126.835L126.775 126.821C126.923 126.715 127.093 126.673 127.241 126.673C127.411 126.673 127.538 126.715 127.666 126.779L127.56 127.012C127.475 126.97 127.39 126.927 127.305 126.927C127.22 126.927 127.135 126.927 127.072 126.949C126.987 126.97 126.923 126.991 126.881 127.033C126.775 127.097 126.711 127.182 126.669 127.267C126.627 127.352 126.584 127.458 126.584 127.542C126.584 127.648 126.584 127.733 126.605 127.839C126.627 127.945 126.669 128.03 126.733 128.115C126.796 128.2 126.86 128.285 126.945 128.348C127.029 128.412 127.114 128.454 127.22 128.497L127.247 128.502C127.341 128.521 127.42 128.537 127.517 128.518C127.623 128.518 127.708 128.475 127.793 128.412C127.856 128.369 127.92 128.327 127.962 128.263C128.005 128.2 128.047 128.136 128.068 128.051C128.09 127.967 128.111 127.882 128.09 127.776L128.344 127.754C128.365 127.86 128.365 127.988 128.323 128.094C128.281 128.2 128.238 128.306 128.153 128.391C128.09 128.475 128.005 128.56 127.899 128.624C127.772 128.709 127.644 128.751 127.517 128.772C127.39 128.793 127.241 128.772 127.114 128.73C126.987 128.687 126.86 128.624 126.754 128.539C126.669 128.475 126.584 128.369 126.521 128.263ZM128.789 125.295L130.21 126.864L130.401 126.694L128.98 125.125L128.789 125.295ZM131.482 122.75L131.016 123.323L132.458 124.51L132.288 124.722L130.846 123.535L130.38 124.107L130.189 123.959L131.27 122.623L131.482 122.75ZM133.539 121.117L132.267 121.138L132.14 121.393L133.688 121.329L134.366 121.711L134.494 121.478L133.815 121.117L133.031 119.76L132.882 120.015L133.539 121.117ZM114.858 104.048L114.71 104.578H114.689C114.604 104.472 114.455 104.429 114.243 104.429H113.586V107.504C113.586 107.61 113.628 107.716 113.713 107.801V107.865H112.929V107.822C113.013 107.737 113.056 107.631 113.056 107.525V104.451H112.356C112.123 104.451 111.974 104.493 111.826 104.641L111.784 104.62L111.996 104.048H112.017C112.08 104.069 112.144 104.09 112.229 104.09H114.646C114.731 104.09 114.795 104.069 114.858 104.048ZM118.802 107.525V104.429C118.802 104.323 118.845 104.217 118.908 104.133V104.09H118.145C118.23 104.217 118.272 104.493 118.272 104.705V105.532H116.343V104.705C116.343 104.493 116.385 104.239 116.47 104.09H115.706V104.133C115.77 104.217 115.812 104.323 115.812 104.429V107.504C115.812 107.61 115.77 107.716 115.706 107.801V107.843H116.47C116.385 107.716 116.343 107.441 116.343 107.228V105.893H118.272V107.25C118.272 107.462 118.23 107.716 118.145 107.865H118.908V107.822C118.845 107.737 118.802 107.631 118.802 107.525ZM122.323 107.186L122.089 107.886C122.026 107.865 121.962 107.844 121.877 107.844H119.948V107.801C120.011 107.716 120.054 107.61 120.054 107.504V104.43C120.054 104.324 120.011 104.218 119.948 104.133V104.09H121.729C121.835 104.09 121.941 104.09 122.026 104.048H122.047V104.748H122.026C121.92 104.514 121.814 104.43 121.496 104.43H120.584V105.532H121.474C121.559 105.532 121.623 105.511 121.665 105.469H121.686V105.978H121.665C121.559 105.914 121.453 105.872 121.347 105.872H120.584V107.504H121.58C121.962 107.504 122.153 107.335 122.301 107.165L122.323 107.186ZM114.032 113.929V113.887C113.968 113.802 113.862 113.59 113.841 113.208L113.65 110.494C113.629 110.388 113.693 110.282 113.777 110.197V110.155H112.972L111.784 112.89L110.639 110.155H109.791V110.197C109.876 110.282 109.939 110.388 109.918 110.494L109.727 113.208C109.706 113.569 109.6 113.781 109.536 113.866V113.908H110.194C110.109 113.781 110.088 113.505 110.109 113.293L110.3 110.706L111.657 113.929H111.742L113.12 110.706L113.29 113.314C113.311 113.526 113.29 113.781 113.205 113.929H114.032ZM118.527 113.887V113.929H117.637C117.658 113.696 117.594 113.463 117.509 113.251L117.17 112.424H115.877L115.537 113.251C115.431 113.484 115.389 113.717 115.41 113.929H114.71V113.887L114.719 113.879C114.864 113.755 114.988 113.649 115.113 113.399L116.279 110.643C116.343 110.494 116.343 110.325 116.258 110.219V110.176H116.788L118.145 113.399C118.25 113.649 118.374 113.756 118.519 113.88L118.527 113.887ZM117.022 112.106L116.513 110.897L116.004 112.106H117.022ZM120.075 110.155H119.312V110.197C119.375 110.282 119.418 110.388 119.418 110.494V113.59C119.418 113.696 119.375 113.802 119.312 113.887V113.929H120.075V113.887C120.012 113.802 119.969 113.696 119.969 113.59V110.494C119.969 110.388 120.012 110.282 120.075 110.197V110.155ZM124.57 110.155V110.197C124.507 110.282 124.464 110.388 124.464 110.494V113.929H124.38L121.665 110.94V113.293C121.665 113.505 121.708 113.781 121.793 113.908H121.178V113.866C121.241 113.781 121.284 113.675 121.284 113.569V110.643C121.284 110.452 121.178 110.282 121.072 110.197V110.155H121.687L124.104 112.827V110.77C124.104 110.558 124.061 110.282 123.977 110.155H124.57ZM114.858 116.728L115.007 116.198L114.985 116.177L114.985 116.177C114.922 116.198 114.858 116.219 114.773 116.219H112.377C112.292 116.219 112.229 116.198 112.165 116.177H112.144L111.932 116.749L111.974 116.771C112.123 116.622 112.271 116.58 112.504 116.58H113.204V119.654C113.204 119.76 113.162 119.866 113.077 119.951V119.994H113.862V119.951C113.777 119.866 113.734 119.76 113.734 119.654V116.58H114.392C114.604 116.58 114.752 116.622 114.837 116.728H114.858ZM118.866 119.951V119.994H117.975C117.997 119.76 117.933 119.527 117.848 119.315L117.509 118.488H116.215L115.876 119.315C115.77 119.548 115.728 119.782 115.749 119.994H115.049V119.951L115.058 119.944L115.058 119.944C115.203 119.82 115.327 119.713 115.452 119.464L116.618 116.707C116.682 116.559 116.682 116.389 116.597 116.283V116.24H117.127L118.484 119.464C118.588 119.714 118.713 119.82 118.858 119.945L118.866 119.951ZM117.36 118.17L116.852 116.961L116.343 118.17H117.36ZM120.669 120.057C121.729 120.057 122.174 119.464 122.174 118.87C122.174 118.213 121.602 117.894 121.305 117.831C121.623 117.682 121.792 117.386 121.792 117.046C121.792 116.559 121.432 116.156 120.52 116.156C120.285 116.156 120.003 116.179 119.752 116.2C119.664 116.207 119.58 116.214 119.502 116.219V116.262C119.566 116.347 119.608 116.453 119.608 116.559V119.654C119.608 119.761 119.566 119.867 119.502 119.951V119.994C119.556 119.997 119.616 120.002 119.681 120.006C119.999 120.028 120.422 120.057 120.669 120.057ZM120.138 116.516C120.244 116.495 120.35 116.495 120.435 116.495C121.05 116.495 121.283 116.728 121.283 117.152C121.283 117.47 121.177 117.788 120.266 117.788H120.138V116.516ZM120.541 118.085C121.305 118.085 121.623 118.382 121.623 118.912C121.623 119.294 121.453 119.697 120.626 119.718C120.499 119.718 120.308 119.697 120.138 119.676V118.107C120.175 118.107 120.227 118.103 120.287 118.098C120.365 118.092 120.457 118.085 120.541 118.085Z"
            fill="white"
            ref={morphProps.bindInterpolation}
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 234 329"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Ellipse_201"
          fill="#E6E6E6"
          d="M142 150 A21.5 5 0 0 1 120.5 155 A21.5 5 0 0 1 99 150 A21.5 5 0 0 1 142 150z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(LoadingImage);
